export const TREASURY = {
  COMMON: {
    STATUS: 'COMMON.STATUS',
    TABLE: {
      EMPTY: {
        DESCRIPTION_WITH_DATE: 'COMMON.TABLE.EMPTY.DESCRIPTION_WITH_DATE',
      },
    },
    MODALS: {
      SEARCH: {
        THIRD_PARTY: {
          PLACEHOLDER: 'TREASURY.MODALS.SEARCH.THIRD_PARTY.PLACEHOLDER',
        },
      },
    },
    PLACEHOLDER: {
      SEARCH: 'PLACEHOLDER.SEARCH',
    },
  },
  PARAMETERS: {
    TITLE: {
      PARAMETERS: 'TREASURY.PARAMETERS.TITLE.PARAMETERS', // Parámetros de Tesorería / Treasury Parameters
      SUBTITLE: 'TREASURY.PARAMETERS.TITLE.SUBTITLE', // Configuración general de tesorería / General treasury configuration
    },

    LOADING: {
      MESSAGE: 'TREASURY.PARAMETERS.LOADING.MESSAGE', // Cargando Parámetros / Loading Parameters
      DESCRIPTION: 'TREASURY.PARAMETERS.LOADING.DESCRIPTION', // Espere Por favor... / Please wait...
    },

    CARDS: {
      INSTITUTIONAL: 'TREASURY.PARAMETERS.CARDS.INSTITUTIONAL', // Información Institucional & Control Temporal y Operativo / Institutional Information & Temporal and Operational Control
      OPERATION: 'TREASURY.PARAMETERS.CARDS.OPERATION', // Operación de Caja y PAC / Cash Operation and PAC
      CONCEPTS: 'TREASURY.PARAMETERS.CARDS.CONCEPTS', // Gestión de Avances & Configuración de Conceptos Contables / Advance Management & Accounting Concepts Configuration
    },

    FIELDS: {
      IDENTIFICATION: {
        LABEL: 'TREASURY.PARAMETERS.FIELDS.IDENTIFICATION.LABEL', // No. Identificación / Identification No.
        TOOLTIP: 'TREASURY.PARAMETERS.FIELDS.IDENTIFICATION.TOOLTIP', // Identidad legal de la empresa / Legal identity of the company
        PLACEHOLDER: 'TREASURY.PARAMETERS.FIELDS.IDENTIFICATION.PLACEHOLDER', // No. Identificación / Identification No.
        REQUIRED: 'TREASURY.PARAMETERS.FIELDS.IDENTIFICATION.REQUIRED', // El número de identificación es requerido / Identification number is required
      },
      ENTITY: {
        LABEL: 'TREASURY.PARAMETERS.FIELDS.ENTITY.LABEL', // Entidad / Entity
        TOOLTIP: 'TREASURY.PARAMETERS.FIELDS.ENTITY.TOOLTIP', // Razón social institucional / Institutional business name
        PLACEHOLDER: 'TREASURY.PARAMETERS.FIELDS.ENTITY.PLACEHOLDER', // Entidad / Entity
        REQUIRED: 'TREASURY.PARAMETERS.FIELDS.ENTITY.REQUIRED', // La entidad es requerida / Entity is required
      },
      VIGENCY: {
        LABEL: 'TREASURY.PARAMETERS.FIELDS.VIGENCY.LABEL', // Vigencia Activa / Active Validity
        TOOLTIP: 'TREASURY.PARAMETERS.FIELDS.VIGENCY.TOOLTIP', // Año fiscal de trabajo actual / Current fiscal year
        PLACEHOLDER: 'TREASURY.PARAMETERS.FIELDS.VIGENCY.PLACEHOLDER', // Vigencia activa / Active validity
        NOT_DEFINED: 'TREASURY.PARAMETERS.FIELDS.VIGENCY.NOT_DEFINED', // No definida / Not defined
      },

      SYSTEM_DATE: {
        LABEL: 'TREASURY.PARAMETERS.FIELDS.SYSTEM_DATE.LABEL', // Fecha del Sistema / System Date
        TOOLTIP: 'TREASURY.PARAMETERS.FIELDS.SYSTEM_DATE.TOOLTIP', // Fecha actual del sistema para operaciones contables / Current system date for accounting operations
        REQUIRED: 'TREASURY.PARAMETERS.FIELDS.SYSTEM_DATE.REQUIRED', // La fecha del Sistema es requerida / System date is required
        AUTOMATIC: 'TREASURY.PARAMETERS.FIELDS.SYSTEM_DATE.AUTOMATIC', // Automático / Automatic
        RESTORE: 'TREASURY.PARAMETERS.FIELDS.SYSTEM_DATE.RESTORE', // Restaurar / Restore
        NOT_AVAILABLE: 'TREASURY.PARAMETERS.FIELDS.SYSTEM_DATE.NOT_AVAILABLE', // No disponible / Not available
      },

      OPERATES_CASH: {
        LABEL: 'TREASURY.PARAMETERS.FIELDS.OPERATES_CASH.LABEL', // ¿La entidad opera caja? / Does the entity operate cash?
        TOOLTIP: 'TREASURY.PARAMETERS.FIELDS.OPERATES_CASH.TOOLTIP', // Indica si la entidad opera con caja / Indicates if the entity operates with cash
        REQUIRED: 'TREASURY.PARAMETERS.FIELDS.OPERATES_CASH.REQUIRED', // Debe indicar si la entidad opera caja / You must indicate if the entity operates cash
      },

      CONTROLS_PAC: {
        LABEL: 'TREASURY.PARAMETERS.FIELDS.CONTROLS_PAC.LABEL', // ¿Controla PAC? / Controls PAC?
        TOOLTIP: 'TREASURY.PARAMETERS.FIELDS.CONTROLS_PAC.TOOLTIP', // Control de Plan Anual de Caja / Annual Cash Plan Control
        REQUIRED: 'TREASURY.PARAMETERS.FIELDS.CONTROLS_PAC.REQUIRED', // Debe indicar si controla PAC / You must indicate if controls PAC
      },

      ACCOUNT: {
        CODE: {
          LABEL: 'TREASURY.PARAMETERS.FIELDS.ACCOUNT.CODE.LABEL', // Código Cuenta / Account Code
          TOOLTIP: 'TREASURY.PARAMETERS.FIELDS.ACCOUNT.CODE.TOOLTIP', // Cuenta contable para operaciones de caja / Accounting account for cash operations
          PLACEHOLDER: 'TREASURY.PARAMETERS.FIELDS.ACCOUNT.CODE.PLACEHOLDER', // Buscar cuenta... / Search account...
          REQUIRED: 'TREASURY.PARAMETERS.FIELDS.ACCOUNT.CODE.REQUIRED', // La cuenta contable es requerida cuando Opera Caja es Sí / Accounting account is required when Cash Operation is Yes
          SEARCH_TOOLTIP: 'TREASURY.PARAMETERS.FIELDS.ACCOUNT.CODE.SEARCH_TOOLTIP', // Buscar cuenta contable / Search accounting account
        },
        NAME: {
          LABEL: 'TREASURY.PARAMETERS.FIELDS.ACCOUNT.NAME.LABEL', // Nombre Cuenta / Account Name
          TOOLTIP: 'TREASURY.PARAMETERS.FIELDS.ACCOUNT.NAME.TOOLTIP', // Nombre de la cuenta contable seleccionada / Name of the selected accounting account
          PLACEHOLDER: 'TREASURY.PARAMETERS.FIELDS.ACCOUNT.NAME.PLACEHOLDER', // Nombre cuenta... / Account name...
        },
      },

      LEGALIZATION_DAYS: {
        LABEL: 'TREASURY.PARAMETERS.FIELDS.LEGALIZATION_DAYS.LABEL', // Días Legalización de Avances / Advance Legalization Days
        TOOLTIP: 'TREASURY.PARAMETERS.FIELDS.LEGALIZATION_DAYS.TOOLTIP', // Días para legalización de gastos en avances / Days for expense legalization in advances
        PLACEHOLDER: 'TREASURY.PARAMETERS.FIELDS.LEGALIZATION_DAYS.PLACEHOLDER', // Ingrese días... / Enter days...
        REQUIRED: 'TREASURY.PARAMETERS.FIELDS.LEGALIZATION_DAYS.REQUIRED', // Los días de legalización son requeridos / Legalization days are required
        HINT: 'TREASURY.PARAMETERS.FIELDS.LEGALIZATION_DAYS.HINT', // Número de días hábiles para legalizar los avances de gastos (1-999) / Number of business days to legalize expense advances (1-999)
      },

      CONCEPTS: {
        INCOME: {
          LABEL: 'TREASURY.PARAMETERS.FIELDS.CONCEPTS.INCOME.LABEL', // Ingresos / Income
          TOOLTIP: 'TREASURY.PARAMETERS.FIELDS.CONCEPTS.INCOME.TOOLTIP', // Concepto para ingresos / Concept for income
          PLACEHOLDER: 'TREASURY.PARAMETERS.FIELDS.CONCEPTS.INCOME.PLACEHOLDER', // Seleccionar concepto... / Select concept...
          REQUIRED: 'TREASURY.PARAMETERS.FIELDS.CONCEPTS.INCOME.REQUIRED', // El concepto de ingresos es requerido / Income concept is required
        },
        EXPENSE: {
          LABEL: 'TREASURY.PARAMETERS.FIELDS.CONCEPTS.EXPENSE.LABEL', // Egresos / Expenses
          TOOLTIP: 'TREASURY.PARAMETERS.FIELDS.CONCEPTS.EXPENSE.TOOLTIP', // Concepto para egresos / Concept for expenses
          PLACEHOLDER: 'TREASURY.PARAMETERS.FIELDS.CONCEPTS.EXPENSE.PLACEHOLDER', // Seleccionar concepto... / Select concept...
          REQUIRED: 'TREASURY.PARAMETERS.FIELDS.CONCEPTS.EXPENSE.REQUIRED', // El concepto de egresos es requerido / Expense concept is required
        },
        TRANSFER: {
          LABEL: 'TREASURY.PARAMETERS.FIELDS.CONCEPTS.TRANSFER.LABEL', // Traslados Bancarios / Bank Transfers
          TOOLTIP: 'TREASURY.PARAMETERS.FIELDS.CONCEPTS.TRANSFER.TOOLTIP', // Concepto para traslados bancarios / Concept for bank transfers
          PLACEHOLDER: 'TREASURY.PARAMETERS.FIELDS.CONCEPTS.TRANSFER.PLACEHOLDER', // Seleccionar concepto... / Select concept...
          REQUIRED: 'TREASURY.PARAMETERS.FIELDS.CONCEPTS.TRANSFER.REQUIRED', // El concepto de traslados es requerido / Transfer concept is required
        },
        DUPLICATE_ERROR: 'TREASURY.PARAMETERS.FIELDS.CONCEPTS.DUPLICATE_ERROR', // El Código no se puede asociar a mas de un concepto / The Code cannot be associated with more than one concept
      },
    },

    HINTS: {
      INSTITUTIONAL: 'TREASURY.PARAMETERS.HINTS.INSTITUTIONAL', // Datos cargados de configuración institucional / Data loaded from institutional configuration
    },

    OPTIONS: {
      YES: 'TREASURY.PARAMETERS.OPTIONS.YES', // Sí / Yes
      NO: 'TREASURY.PARAMETERS.OPTIONS.NO', // No / No
    },

    ALERTS: {
      LOAD_ERROR: {
        TITLE: 'TREASURY.PARAMETERS.ALERTS.LOAD_ERROR.TITLE', // Error al cargar datos / Error loading data
        MESSAGE: 'TREASURY.PARAMETERS.ALERTS.LOAD_ERROR.MESSAGE', // Ocurrió un error al cargar los datos / An error occurred while loading data
      },
      SAVE_SUCCESS: {
        TITLE: 'TREASURY.PARAMETERS.ALERTS.SAVE_SUCCESS.TITLE', // Parámetros guardados / Parameters saved
        MESSAGE: 'TREASURY.PARAMETERS.ALERTS.SAVE_SUCCESS.MESSAGE', // La configuración ha sido guardada exitosamente / Configuration has been saved successfully
      },
      SAVE_ERROR: {
        TITLE: 'TREASURY.PARAMETERS.ALERTS.SAVE_ERROR.TITLE', // Error al guardar / Error saving
        MESSAGE: 'TREASURY.PARAMETERS.ALERTS.SAVE_ERROR.MESSAGE', // Ocurrió un error al guardar los parámetros / An error occurred while saving parameters
      },
      RESTORE_SUCCESS: {
        TITLE: 'TREASURY.PARAMETERS.ALERTS.RESTORE_SUCCESS.TITLE', // Fecha restaurada / Date restored
        MESSAGE: 'TREASURY.PARAMETERS.ALERTS.RESTORE_SUCCESS.MESSAGE', // La fecha del sistema ha sido restaurada / System date has been restored
      },
      RESTORE_ERROR: {
        TITLE: 'TREASURY.PARAMETERS.ALERTS.RESTORE_ERROR.TITLE', // Error al restaurar fecha / Error restoring date
        MESSAGE: 'TREASURY.PARAMETERS.ALERTS.RESTORE_ERROR.MESSAGE', // Error al restaurar la fecha del sistema / Error restoring system date
      },
    },

    ACTIONS: {
      REFRESH: 'ACTIONS.REFRESH', // Refrescar / Refresh
      CANCEL: 'ACTIONS.CANCEL', // Cancelar / Cancel
      SAVE: 'ACTIONS.SAVE', // Guardar / Save
      SAVING: 'UTIL.SAVING', // Guardando... / Saving...
      RESTORE: 'TREASURY.PARAMETERS.FIELDS.SYSTEM_DATE.RESTORE', // Restaurar / Restore
    },

    VALIDATIONS: {
      DATE_INVALID: 'TREASURY.PARAMETERS.VALIDATIONS.DATE_INVALID', // La fecha es inválida / The date is invalid
      REQUIRED_FIELD: 'TREASURY.PARAMETERS.VALIDATIONS.REQUIRED_FIELD', // Este campo es requerido / This field is required
      MIN_DAYS: 'TREASURY.PARAMETERS.VALIDATIONS.MIN_DAYS', // El número mínimo de días es 1 / The minimum number of days is 1
      MAX_DAYS: 'TREASURY.PARAMETERS.VALIDATIONS.MAX_DAYS', // El número máximo de días es 999 / The maximum number of days is 999
    },

    ACCOUNT_SEARCH: {
      TITLE: 'TREASURY.PARAMETERS.ACCOUNT_SEARCH.TITLE', // Buscar Cuenta Contable / Search Accounting Account
      SEARCH_PLACEHOLDER: 'TREASURY.PARAMETERS.ACCOUNT_SEARCH.SEARCH_PLACEHOLDER', // Buscar por código o nombre... / Search by code or name...
      EMPTY_MESSAGE: 'TREASURY.PARAMETERS.ACCOUNT_SEARCH.EMPTY_MESSAGE', // No se encontraron cuentas / No accounts found
      EMPTY_DESCRIPTION: 'TREASURY.PARAMETERS.ACCOUNT_SEARCH.EMPTY_DESCRIPTION', // Intente con otro término de búsqueda / Try another search term
      SELECT: 'TREASURY.PARAMETERS.ACCOUNT_SEARCH.SELECT', // Seleccionar / Select
      CLEAR: 'TREASURY.PARAMETERS.ACCOUNT_SEARCH.CLEAR', // Limpiar / Clear
      CLOSE: 'TREASURY.PARAMETERS.ACCOUNT_SEARCH.CLOSE', // Cerrar / Close
    },

    FIELD_ERRORS: {
      ACCOUNT_REQUIRED: 'TREASURY.PARAMETERS.FIELD_ERRORS.ACCOUNT_REQUIRED', // La cuenta contable es requerida cuando Opera Caja es Sí / Accounting account is required when Cash Operation is Yes
      CONCEPT_DUPLICATE: 'TREASURY.PARAMETERS.FIELD_ERRORS.CONCEPT_DUPLICATE', // El Código no se puede asociar a mas de un concepto / The Code cannot be associated with more than one concept
      LEGALIZATION_DAYS_INVALID: 'TREASURY.PARAMETERS.FIELD_ERRORS.LEGALIZATION_DAYS_INVALID', // Los días de legalización deben ser un número entre 1 y 999 / Legalization days must be a number between 1 and 999
      DATE_INVALID: 'TREASURY.PARAMETERS.FIELD_ERRORS.DATE_INVALID', // La fecha del sistema no puede ser anterior al último mes cerrado / System date cannot be earlier than the last closed month
    },

    CONFIRM_DIALOGS: {
      CANCEL: {
        TITLE: 'TREASURY.PARAMETERS.CONFIRM_DIALOGS.CANCEL.TITLE', // Cancelar cambios / Cancel changes
        MESSAGE: 'TREASURY.PARAMETERS.CONFIRM_DIALOGS.CANCEL.MESSAGE', // ¿Está seguro de que desea cancelar los cambios? Se perderán todas las modificaciones no guardadas. / Are you sure you want to cancel the changes? All unsaved modifications will be lost.
        CONFIRM_LABEL: 'TREASURY.PARAMETERS.CONFIRM_DIALOGS.CANCEL.CONFIRM_LABEL', // Sí, cancelar / Yes, cancel
        CANCEL_LABEL: 'TREASURY.PARAMETERS.CONFIRM_DIALOGS.CANCEL.CANCEL_LABEL', // Continuar editando    / Continue editing
      },
      REFRESH: {
        TITLE: 'TREASURY.PARAMETERS.CONFIRM_DIALOGS.REFRESH.TITLE', // Cambios sin guardar / Unsaved changes
        MESSAGE: '', // Tiene cambios sin guardar. Si refresca, perderá los cambios. ¿Está seguro de que desea continuar? / You have unsaved changes. If you refresh, you will lose the changes. Are you sure you want to continue?
        CONFIRM_LABEL: 'TREASURY.PARAMETERS.CONFIRM_DIALOGS.REFRESH.CONFIRM_LABEL', // Sí, refrescar / Yes, refresh
      },
      RESTORE_DATE: {
        TITLE: 'TREASURY.PARAMETERS.CONFIRM_DIALOGS.RESTORE_DATE.TITLE', // Restaurar fecha del sistema / Restore system date
        MESSAGE: 'TREASURY.PARAMETERS.CONFIRM_DIALOGS.RESTORE_DATE.MESSAGE', // ¿Está seguro de que desea restaurar la fecha del sistema a la fecha del servidor? Esto puede afectar las operaciones contables. / Are you sure you want to restore the system date to the server date? This may affect accounting operations.
        CONFIRM_LABEL: 'TREASURY.PARAMETERS.CONFIRM_DIALOGS.RESTORE_DATE.CONFIRM_LABEL', // Sí, restaurar / Yes, restore
      },
      CLEAR_ACCOUNT: {
        TITLE: 'TREASURY.PARAMETERS.CONFIRM_DIALOGS.CLEAR_ACCOUNT.TITLE', // Limpiar cuenta contable / Clear accounting account
        MESSAGE: 'TREASURY.PARAMETERS.CONFIRM_DIALOGS.CLEAR_ACCOUNT.MESSAGE', // ¿Está seguro de que desea eliminar la cuenta contable seleccionada? / Are you sure you want to delete the selected accounting account?
        CONFIRM_LABEL: 'TREASURY.PARAMETERS.CONFIRM_DIALOGS.CLEAR_ACCOUNT.CONFIRM_LABEL', // Cancelar cuenta / Clear account
      },
    },

    // Mensajes de permiso denegado
    PERMISSION: {
      DENIED_RESTORE_DATE: 'TREASURY.PARAMETERS.PERMISSION.DENIED_RESTORE_DATE', // No tiene permisos para restaurar la fecha del sistema / You do not have permission to restore the system date
      DENIED_SELECT_ACCOUNT: 'TREASURY.PARAMETERS.PERMISSION.DENIED_SELECT_ACCOUNT', // No tiene permisos para seleccionar cuentas /  You do not have permission to select accounts.
      DENIED_CLEAR_ACCOUNT: 'TREASURY.PARAMETERS.PERMISSION.DENIED_CLEAR_ACCOUNT', // No tiene permisos para limpiar cuentas /  You do not have permission to clear accounts.
    },

    // Mensajes de éxito/información
    MESSAGES: {
      ACCOUNT_SELECTED: 'TREASURY.PARAMETERS.MESSAGES.ACCOUNT_SELECTED', // Cuenta seleccionada: / Selected account:
      ACCOUNT_CLEARED: 'TREASURY.PARAMETERS.MESSAGES.ACCOUNT_CLEARED', // Cuenta contable eliminada / Accounting account deleted
      ERROR_SEARCH_ACCOUNT: 'TREASURY.PARAMETERS.MESSAGES.ERROR_SEARCH_ACCOUNT', // Error al buscar cuenta contable / Error searching for accounting account
    },

    ACCOUNT_MODAL: {
      TITLE: 'TREASURY.PARAMETERS.ACCOUNT_MODAL.TITLE', // Seleccionar Cuenta Contable para Caja /  Select Accounting Account for Cash
    },
  },
  // Cuentas Bancarias - Bank Accounts
  BANK_ACCOUNTS: {
    TITLE: {
      LIST: 'TREASURY.BANK_ACCOUNTS.TITLE.LIST', // Cuentas Bancarias / Bank Accounts
      CREATE: 'TREASURY.BANK_ACCOUNTS.TITLE.CREATE', // Crear Cuenta de Banco / Create Bank Account
      EDIT: 'TREASURY.BANK_ACCOUNTS.TITLE.EDIT', // Editar Cuenta de Banco / Edit Bank Account
      VIEW: 'TREASURY.BANK_ACCOUNTS.TITLE.VIEW', // Consultar Cuenta de Banco / View Bank Account
    },

    SUBTITLE: {
      LIST: 'TREASURY.BANK_ACCOUNTS.SUBTITLE.LIST', // Maestro de cuentas bancarias de la entidad / Bank accounts master for the entity
      CREATE: 'TREASURY.BANK_ACCOUNTS.SUBTITLE.CREATE', // Complete los datos de la nueva cuenta de banco / Complete the new bank account details
      EDIT: 'TREASURY.BANK_ACCOUNTS.SUBTITLE.EDIT', // Actualice los datos permitidos de la cuenta bancaria / Update the allowed bank account data
      VIEW: 'TREASURY.BANK_ACCOUNTS.SUBTITLE.VIEW', // Detalle de la cuenta de banco / Bank account detail
    },

    SECTION: {
      ACCOUNT_DATA: 'TREASURY.BANK_ACCOUNTS.SECTION.ACCOUNT_DATA', // Datos de la cuenta / Account details
      CONTACT: 'TREASURY.BANK_ACCOUNTS.SECTION.CONTACT', // Contacto / Contact
      ACCOUNTING_ACCOUNT: 'TREASURY.BANK_ACCOUNTS.SECTION.ACCOUNTING_ACCOUNT', // Cuenta contable / GL Account
    },

    LABEL: {
      BANK: 'TREASURY.BANK_ACCOUNTS.LABEL.BANK', // Banco / Bank
      IDENTIFICATION: 'TREASURY.BANK_ACCOUNTS.LABEL.IDENTIFICATION', // No. Identificación / ID Number
      NATIONAL_CODE: 'TREASURY.BANK_ACCOUNTS.LABEL.NATIONAL_CODE', // Cód. Nacional / National Code
      ACCOUNT_TYPE: 'TREASURY.BANK_ACCOUNTS.LABEL.ACCOUNT_TYPE', // Tipo de cuenta / Account Type
      ACCOUNT_NUMBER: 'TREASURY.BANK_ACCOUNTS.LABEL.ACCOUNT_NUMBER', // # Cuenta bancaria / Bank Account Number
      ACCOUNT_CODE: 'TREASURY.BANK_ACCOUNTS.LABEL.ACCOUNT_CODE', // Cod. Cuenta / Account Code
      ACCOUNT_NAME: 'TREASURY.BANK_ACCOUNTS.LABEL.ACCOUNT_NAME', // Nombre de la cuenta / Account Name
      STATUS: 'TREASURY.BANK_ACCOUNTS.LABEL.STATUS', // Estado / Status
      OVERDRAFT: 'TREASURY.BANK_ACCOUNTS.LABEL.OVERDRAFT', // Sobregiro / Overdraft
      CHECKBOOK: 'TREASURY.BANK_ACCOUNTS.LABEL.CHECKBOOK', // Opera chequera / Checkbook
      CHECK_CONSECUTIVE: 'TREASURY.BANK_ACCOUNTS.LABEL.CHECK_CONSECUTIVE', // Consecutivo chequera / Checkbook consecutive
      CLOSING_DATE: 'TREASURY.BANK_ACCOUNTS.LABEL.CLOSING_DATE', // Fecha de cierre / Closing Date
      MIN_BALANCE: 'TREASURY.BANK_ACCOUNTS.LABEL.MIN_BALANCE', // Saldo mínimo / Minimum Balance
      FUNDING_SOURCE: 'TREASURY.BANK_ACCOUNTS.LABEL.FUNDING_SOURCE', // Fuente financiación / Funding Source
      CONTACT_NAME: 'TREASURY.BANK_ACCOUNTS.LABEL.CONTACT_NAME', // Nombre contacto / Contact Name
      POSITION: 'TREASURY.BANK_ACCOUNTS.LABEL.POSITION', // Cargo / Position
      PHONE: 'COMMON.PHONE', // Teléfono / Phone (common_keys)
      EMAIL: 'COMMON.EMAIL', // Email (common_keys)
      GL_ACCOUNT: 'TREASURY.BANK_ACCOUNTS.LABEL.GL_ACCOUNT', // Cuenta contable / GL Account
      GL_ACCOUNT_TOOLTIP: 'TREASURY.BANK_ACCOUNTS.LABEL.GL_ACCOUNT_TOOLTIP', // Cuenta de movimiento asociada / Associated movement account
    },

    COLUMN: {
      BANK_CODE: 'TREASURY.BANK_ACCOUNTS.COLUMN.BANK_CODE', // Cod. Banco / Bank Code
      ACCOUNT_NUMBER: 'TREASURY.BANK_ACCOUNTS.COLUMN.ACCOUNT_NUMBER', // # Cuenta / Account #
      NAME: 'TREASURY.BANK_ACCOUNTS.COLUMN.NAME', // Nombre / Name
      STATUS: 'TREASURY.BANK_ACCOUNTS.COLUMN.STATUS', // Estado / Status
      IDENTIFICATION: 'TREASURY.BANK_ACCOUNTS.COLUMN.IDENTIFICATION', // No. Identificación / ID Number
      BANK: 'TREASURY.BANK_ACCOUNTS.COLUMN.BANK', // Banco / Bank
      FUNDING_SOURCE: 'TREASURY.BANK_ACCOUNTS.COLUMN.FUNDING_SOURCE', // Fuente Financiación / Funding Source
      ACTIONS: 'COMMON.ACTIONS', // Acciones / Actions (common_keys)
    },

    ACTION: {
      CREATE: 'TREASURY.BANK_ACCOUNTS.ACTION.CREATE', // Crear Cuenta de Banco / Create Bank Account (específico HU)
      VIEW: 'ACTIONS.VIEW', // Consultar / View (common_keys)
      EDIT: 'ACTIONS.EDIT', // Editar / Edit (common_keys)
      DELETE: 'ACTIONS.DELETE', // Eliminar / Delete (common_keys)
      SEARCH: 'ACTIONS.SEARCH', // Buscar / Search (common_keys)
      UNLINK_GL: 'TREASURY.BANK_ACCOUNTS.ACTION.UNLINK_GL', // Desasociar cuenta contable / Unlink GL account
    },

    COUNTER: {
      SINGULAR: 'TREASURY.BANK_ACCOUNTS.COUNTER.SINGULAR', // cuenta bancaria / bank account
      PLURAL: 'TREASURY.BANK_ACCOUNTS.COUNTER.PLURAL', // cuentas bancarias / bank accounts
    },

    OPTION: {
      SAVINGS: 'TREASURY.BANK_ACCOUNTS.OPTION.SAVINGS', // Ahorros / Savings
      CHECKING: 'TREASURY.BANK_ACCOUNTS.OPTION.CHECKING', // Corriente / Checking
      INVESTMENT: 'TREASURY.BANK_ACCOUNTS.OPTION.INVESTMENT', // Inversión / Investment
      DIGITAL: 'TREASURY.BANK_ACCOUNTS.OPTION.DIGITAL', // Digital / Digital
      CROSS: 'TREASURY.BANK_ACCOUNTS.OPTION.CROSS', // Cruce / Cross
      ACTIVE: 'COMMON.ACTIVE', // Activo / Active (common_keys)
      INACTIVE: 'TREASURY.BANK_ACCOUNTS.OPTION.INACTIVE', // Inactivo / Inactive (no hay COMMON.INACTIVE)
    },

    MODAL: {
      SELECT_BANK: 'TREASURY.BANK_ACCOUNTS.MODAL.SELECT_BANK', // Seleccionar Banco / Select Bank
      SELECT_GL: 'TREASURY.BANK_ACCOUNTS.MODAL.SELECT_GL', // Seleccionar Cuenta Contable / Select GL Account
      COL_SUP_CODE: 'TREASURY.BANK_ACCOUNTS.MODAL.COL_SUP_CODE', // Cód. Sup. Bancaria / Banking Superintendency Code
      COL_IDENTIFICATION: 'TREASURY.BANK_ACCOUNTS.LABEL.IDENTIFICATION', // No. Identificación (reusa label)
      COL_FULL_NAME: 'TREASURY.BANK_ACCOUNTS.MODAL.COL_FULL_NAME', // Nombre o Razón Social / Name or Business Name
      SEARCH_PLACEHOLDER: 'TREASURY.BANK_ACCOUNTS.MODAL.SEARCH_PLACEHOLDER', // Buscar por código, documento o nombre... / Search by code, document or name...
    },

    PLACEHOLDER: {
      SEARCH: 'TREASURY.BANK_ACCOUNTS.PLACEHOLDER.SEARCH', // Buscar por código, nombre, identificación o banco / Search by code, name, ID or bank
      SELECT_BANK: 'TREASURY.BANK_ACCOUNTS.PLACEHOLDER.SELECT_BANK', // Seleccione el banco / Select bank
      SELECT_GL: 'TREASURY.BANK_ACCOUNTS.PLACEHOLDER.SELECT_GL', // Seleccione la cuenta contable / Select GL account
      FUNDING_SOURCE: 'TREASURY.BANK_ACCOUNTS.PLACEHOLDER.FUNDING_SOURCE', // Código / nombre de fuente / Source code / name
    },

    EMPTY: {
      SEARCH: 'TREASURY.BANK_ACCOUNTS.EMPTY.SEARCH', // No se encontraron cuentas bancarias que coincidan con los criterios de búsqueda. / No bank accounts matched the search criteria.
      DEFAULT: 'TREASURY.BANK_ACCOUNTS.EMPTY.DEFAULT', // No se encontraron cuentas bancarias / No bank accounts found
      DESCRIPTION: 'TREASURY.BANK_ACCOUNTS.EMPTY.DESCRIPTION', // Intenta con otro término o registra una nueva cuenta de banco. / Try another term or register a new bank account.
    },

    MESSAGE: {
      CREATED: 'TREASURY.BANK_ACCOUNTS.MESSAGE.CREATED', // La cuenta de banco se creó exitosamente / Bank account created successfully
      UPDATED: 'TREASURY.BANK_ACCOUNTS.MESSAGE.UPDATED', // La cuenta de banco se actualizó exitosamente / Bank account updated successfully
      DELETED: 'TREASURY.BANK_ACCOUNTS.MESSAGE.DELETED', // La cuenta de banco se eliminó exitosamente / Bank account deleted successfully
      ALREADY_DELETED: 'TREASURY.BANK_ACCOUNTS.MESSAGE.ALREADY_DELETED', // Esta cuenta bancaria ya fue eliminada. / This bank account was already deleted.
      DELETE_ONLY_INACTIVE: 'TREASURY.BANK_ACCOUNTS.MESSAGE.DELETE_ONLY_INACTIVE', // Solo se pueden eliminar cuentas bancarias en estado Inactivo. / Only inactive bank accounts can be deleted.
      DELETE_HAS_GL: 'TREASURY.BANK_ACCOUNTS.MESSAGE.DELETE_HAS_GL', // No se puede eliminar la cuenta bancaria porque tiene una cuenta contable asociada. / Cannot delete the bank account because it has an associated GL account.
      DELETE_NOT_ALLOWED: 'TREASURY.BANK_ACCOUNTS.MESSAGE.DELETE_NOT_ALLOWED', // No se puede eliminar la cuenta bancaria con las condiciones actuales. / Cannot delete the bank account under the current conditions.
      OVERDRAFT_NEGATIVE: 'TREASURY.BANK_ACCOUNTS.MESSAGE.OVERDRAFT_NEGATIVE', // No se puede cambiar el sobregiro a No porque el saldo de la cuenta es negativo. / Cannot change overdraft to No because the account balance is negative.
      HAS_ASSOCIATIONS: 'TREASURY.BANK_ACCOUNTS.MESSAGE.HAS_ASSOCIATIONS', // No se puede eliminar la cuenta bancaria porque tiene transacciones o registros asociados. / Cannot delete the bank account because it has associated transactions or records.
    },

    CONFIRM: {
      DELETE_TITLE: 'TREASURY.BANK_ACCOUNTS.CONFIRM.DELETE_TITLE', // Confirmar eliminación / Confirm deletion
      DELETE_MESSAGE: 'TREASURY.BANK_ACCOUNTS.CONFIRM.DELETE_MESSAGE', // Se va a eliminar la cuenta de banco seleccionada. ¿Desea continuar? / The selected bank account will be deleted. Do you want to continue?
      DELETE_CONFIRM: 'ACTIONS.ACCEPT', // Aceptar / Accept (common_keys)
      DELETE_CANCEL: 'ACTIONS.CANCEL', // Cancelar / Cancel (common_keys)
      CANCEL_EDIT_TITLE: 'TREASURY.BANK_ACCOUNTS.CONFIRM.CANCEL_EDIT_TITLE', // Cancelar modificaciones / Cancel changes
      CANCEL_EDIT_MESSAGE: 'TREASURY.BANK_ACCOUNTS.CONFIRM.CANCEL_EDIT_MESSAGE', // Se cancelarán las modificaciones a la cuenta bancaria / Changes to the bank account will be discarded
      CANCEL_EDIT_CONFIRM: 'TREASURY.BANK_ACCOUNTS.CONFIRM.CANCEL_EDIT_CONFIRM', // Sí, cancelar / Yes, cancel (contexto específico)
      CANCEL_EDIT_CONTINUE: 'TREASURY.BANK_ACCOUNTS.CONFIRM.CANCEL_EDIT_CONTINUE', // Continuar editando / Continue editing (texto específico HU)
      CANCEL_CREATE_TITLE: 'TREASURY.BANK_ACCOUNTS.CONFIRM.CANCEL_CREATE_TITLE', // Cancelar creación / Cancel creation
      CANCEL_CREATE_MESSAGE: 'TREASURY.BANK_ACCOUNTS.CONFIRM.CANCEL_CREATE_MESSAGE', // Se cancelará la creación de la cuenta bancaria / Bank account creation will be cancelled
      CANCEL_CREATE_CONFIRM: 'ACTIONS.ACCEPT', // Aceptar / Accept (common_keys)
      CANCEL_CREATE_CONTINUE: 'ACTIONS.CANCEL', // Cancelar / Cancel (common_keys)
      UNLINK_GL_TITLE: 'TREASURY.BANK_ACCOUNTS.CONFIRM.UNLINK_GL_TITLE', // Desasociar cuenta contable / Unlink GL account
      UNLINK_GL_MESSAGE: 'TREASURY.BANK_ACCOUNTS.CONFIRM.UNLINK_GL_MESSAGE', // Se va a desasociar la cuenta contable a la cuenta de banco / The GL account will be unlinked from the bank account
    },
  },

  DEDUCTIONS: {
    TITLE: {
      LIST: 'TREASURY.DEDUCTIONS.TITLE.LIST', // Otras Deducciones / Other Deductions
      CREATE: 'TREASURY.DEDUCTIONS.TITLE.CREATE', // Registrar Deducción / Register Deduction
      EDIT: 'TREASURY.DEDUCTIONS.TITLE.EDIT', // Editar Deducción / Edit Deduction
      VIEW: 'TREASURY.DEDUCTIONS.TITLE.VIEW', // Consultar Deducción / View Deduction
      FINALIZE: 'TREASURY.DEDUCTIONS.TITLE.FINALIZE', // Finalizar Deducción / Finalize Deduction
      SUBTITLE: {
        LIST: 'TREASURY.DEDUCTIONS.TITLE.SUBTITLE.LIST', // Maestro de otras deducciones de Tesorería / Treasury other deductions master
        CREATE: 'TREASURY.DEDUCTIONS.TITLE.SUBTITLE.CREATE', // Complete los datos de la nueva deducción / Complete the data for the new deduction
        EDIT: 'TREASURY.DEDUCTIONS.TITLE.SUBTITLE.EDIT', // Solo campos permitidos son editables (RN-ALC3-01) / Only allowed fields are editable (RN-ALC3-01)
        VIEW: 'TREASURY.DEDUCTIONS.TITLE.SUBTITLE.VIEW', // Detalle completo de la deducción / Complete deduction details
        FINALIZE: 'TREASURY.DEDUCTIONS.TITLE.SUBTITLE.FINALIZE', // Complete los datos para finalizar la deducción / Complete the data to finalize the deduction
      },
    },

    LOADING: {
      MESSAGE: 'TREASURY.DEDUCTIONS.LOADING.MESSAGE', // Cargando deducciones / Loading deductions
      DESCRIPTION: 'TREASURY.DEDUCTIONS.LOADING.DESCRIPTION', // Espere Por favor... / Please wait...
    },

    RESULTS_COUNTER: {
      SINGULAR: 'TREASURY.DEDUCTIONS.RESULTS_COUNTER.SINGULAR', // deducción / deduction
      PLURAL: 'TREASURY.DEDUCTIONS.RESULTS_COUNTER.PLURAL', // deducciones / deductions
    },

    FILTERS: {
      ESTADO: {
        LABEL: 'TREASURY.DEDUCTIONS.FILTERS.ESTADO.LABEL', // Estado / Status
        PLACEHOLDER: 'TREASURY.DEDUCTIONS.FILTERS.ESTADO.PLACEHOLDER', // Seleccionar estado / Select status
        OPTIONS: {
          ACTIVO: 'COMMON.ACTIVE', // Activo / Active (common_keys)
          INACTIVO: 'TREASURY.DEDUCTIONS.FILTERS.ESTADO.OPTIONS.INACTIVO', // Inactivo / Inactive
          FINALIZADO: 'TREASURY.DEDUCTIONS.FILTERS.ESTADO.OPTIONS.FINALIZADO', // Finalizado / Finalized
        },
      },
      SEARCH: {
        PLACEHOLDER: 'TREASURY.DEDUCTIONS.FILTERS.SEARCH.PLACEHOLDER', // Buscar por deudor, acreedor o documento... / Search by debtor, creditor or document...
      },
    },

    EMPTY: {
      MESSAGE: 'TREASURY.DEDUCTIONS.EMPTY.MESSAGE', // No se encontraron deducciones / No deductions found
      DESCRIPTION: 'TREASURY.DEDUCTIONS.EMPTY.DESCRIPTION', // Intenta con otro término o registra una nueva deducción. / Try another term or register a new deduction.
    },

    TABLE: {
      COLUMNS: {
        CONSECUTIVO: 'TREASURY.DEDUCTIONS.TABLE.COLUMNS.CONSECUTIVO', // Consecutivo / Consecutive
        TIPO_DEDUCCION: 'TREASURY.DEDUCTIONS.TABLE.COLUMNS.TIPO_DEDUCCION', // Tipo Deducción / Deduction Type
        ID_DEUDOR: 'TREASURY.DEDUCTIONS.TABLE.COLUMNS.ID_DEUDOR', // ID Deudor / Debtor ID
        NOMBRE_DEUDOR: 'TREASURY.DEDUCTIONS.TABLE.COLUMNS.NOMBRE_DEUDOR', // Nombre Deudor / Debtor Name
        ID_ACREEDOR: 'TREASURY.DEDUCTIONS.TABLE.COLUMNS.ID_ACREEDOR', // ID Acreedor / Creditor ID
        NOMBRE_ACREEDOR: 'TREASURY.DEDUCTIONS.TABLE.COLUMNS.NOMBRE_ACREEDOR', // Nombre Acreedor / Creditor Name
        FECHA_INICIO: 'TREASURY.DEDUCTIONS.TABLE.COLUMNS.FECHA_INICIO', // Fecha Inicio / Start Date
        SALDO_DEDUCCION: 'TREASURY.DEDUCTIONS.TABLE.COLUMNS.SALDO_DEDUCCION', // Saldo Deducción / Deduction Balance
        ESTADO: 'TREASURY.DEDUCTIONS.TABLE.COLUMNS.ESTADO', // Estado / Status
      },
      ACTIONS: {
        LABEL: 'COMMON.ACTIONS', // Acciones / Actions (common_keys)
        VIEW: 'ACTIONS.VIEW', // Consultar / View (common_keys)
        EDIT: 'ACTIONS.EDIT', // Editar / Edit (common_keys)
        FINALIZE: 'TREASURY.DEDUCTIONS.TABLE.ACTIONS.FINALIZE', // Finalizar / Finalize (específico HU)
        DELETE: 'ACTIONS.DELETE', // Eliminar / Delete (common_keys)
      },
    },

    FORM: {
      FIELDS: {
        CONSECUTIVO: {
          LABEL: 'TREASURY.DEDUCTIONS.FORM.FIELDS.CONSECUTIVO.LABEL', // Consecutivo / Consecutive
          TOOLTIP: 'TREASURY.DEDUCTIONS.FORM.FIELDS.CONSECUTIVO.TOOLTIP', // Se asigna automáticamente al guardar / Automatically assigned when saving
          PLACEHOLDER: 'TREASURY.DEDUCTIONS.FORM.FIELDS.CONSECUTIVO.PLACEHOLDER', // Se asigna al guardar / Assigned when saving
        },
        DEUDOR: {
          LABEL: 'TREASURY.DEDUCTIONS.FORM.FIELDS.DEUDOR.LABEL', // ID Deudor / Debtor ID
          TOOLTIP: 'TREASURY.DEDUCTIONS.FORM.FIELDS.DEUDOR.TOOLTIP', // Máximo 12 dígitos / Maximum 12 digits
          PLACEHOLDER: 'TREASURY.DEDUCTIONS.FORM.FIELDS.DEUDOR.PLACEHOLDER', // Seleccione el deudor / Select the debtor
          REQUIRED: 'TREASURY.DEDUCTIONS.FORM.FIELDS.DEUDOR.REQUIRED', // El deudor es requerido / Debtor is required
          SEARCH_TOOLTIP: 'TREASURY.DEDUCTIONS.FORM.FIELDS.DEUDOR.SEARCH_TOOLTIP', // Buscar deudor / Search debtor
        },
        NOMBRE_DEUDOR: {
          LABEL: 'TREASURY.DEDUCTIONS.FORM.FIELDS.NOMBRE_DEUDOR.LABEL', // Nombre Deudor / Debtor Name
          TOOLTIP: 'TREASURY.DEDUCTIONS.FORM.FIELDS.NOMBRE_DEUDOR.TOOLTIP', // Se autocompleta al seleccionar el ID Deudor / Auto-completes when selecting Debtor ID
          PLACEHOLDER: 'TREASURY.DEDUCTIONS.FORM.FIELDS.NOMBRE_DEUDOR.PLACEHOLDER', // Se autocompleta / Auto-completes
        },
        TIPO_DEDUCCION: {
          LABEL: 'TREASURY.DEDUCTIONS.FORM.FIELDS.TIPO_DEDUCCION.LABEL', // Tipo Deducción / Deduction Type
          TOOLTIP: 'TREASURY.DEDUCTIONS.FORM.FIELDS.TIPO_DEDUCCION.TOOLTIP', // Define el tipo de descuento (RN-ALC2-07) / Defines the discount type (RN-ALC2-07)
          PLACEHOLDER: 'TREASURY.DEDUCTIONS.FORM.FIELDS.TIPO_DEDUCCION.PLACEHOLDER', // Seleccionar tipo / Select type
          REQUIRED: 'TREASURY.DEDUCTIONS.FORM.FIELDS.TIPO_DEDUCCION.REQUIRED', // El tipo de deducción es requerido / Deduction type is required
          OPTIONS: {
            CREDITO: 'TREASURY.DEDUCTIONS.FORM.FIELDS.TIPO_DEDUCCION.OPTIONS.CREDITO', // Crédito / Credit
            SANCION: 'TREASURY.DEDUCTIONS.FORM.FIELDS.TIPO_DEDUCCION.OPTIONS.SANCION', // Sanción / Sanction
            APORTE_VOLUNTARIO:
              'TREASURY.DEDUCTIONS.FORM.FIELDS.TIPO_DEDUCCION.OPTIONS.APORTE_VOLUNTARIO', // Aportes Voluntarios / Voluntary Contributions
            OTROS: 'TREASURY.DEDUCTIONS.FORM.FIELDS.TIPO_DEDUCCION.OPTIONS.OTROS', // Otros / Others
          },
        },
        DOCUMENTO: {
          LABEL: 'TREASURY.DEDUCTIONS.FORM.FIELDS.DOCUMENTO.LABEL', // Documento / Document
          TOOLTIP: 'TREASURY.DEDUCTIONS.FORM.FIELDS.DOCUMENTO.TOOLTIP', // Número de documento (único por deudor) / Document number (unique per debtor)
          PLACEHOLDER: 'TREASURY.DEDUCTIONS.FORM.FIELDS.DOCUMENTO.PLACEHOLDER', // Máximo 20 caracteres / Maximum 20 characters
          REQUIRED: 'TREASURY.DEDUCTIONS.FORM.FIELDS.DOCUMENTO.REQUIRED', // El documento es requerido / Document is required
          MAX_LENGTH: 'TREASURY.DEDUCTIONS.FORM.FIELDS.DOCUMENTO.MAX_LENGTH', // Máximo 20 caracteres / Maximum 20 characters
        },
        FECHA_INICIO: {
          LABEL: 'TREASURY.DEDUCTIONS.FORM.FIELDS.FECHA_INICIO.LABEL', // Fecha Inicio / Start Date
          TOOLTIP: 'TREASURY.DEDUCTIONS.FORM.FIELDS.FECHA_INICIO.TOOLTIP', // Inicio de la deducción (RN-ALC2-06) / Deduction start (RN-ALC2-06)
          PLACEHOLDER: 'TREASURY.DEDUCTIONS.FORM.FIELDS.FECHA_INICIO.PLACEHOLDER', // dd/MM/yyyy
          REQUIRED: 'TREASURY.DEDUCTIONS.FORM.FIELDS.FECHA_INICIO.REQUIRED', // La fecha de inicio es requerida / Start date is required
        },
        PERIODICIDAD: {
          LABEL: 'TREASURY.DEDUCTIONS.FORM.FIELDS.PERIODICIDAD.LABEL', // Periodicidad / Frequency
          TOOLTIP: 'TREASURY.DEDUCTIONS.FORM.FIELDS.PERIODICIDAD.TOOLTIP', // Frecuencia de la deducción (RN-ALC2-07) / Deduction frequency (RN-ALC2-07)
          PLACEHOLDER: 'TREASURY.DEDUCTIONS.FORM.FIELDS.PERIODICIDAD.PLACEHOLDER', // Seleccionar periodicidad / Select frequency
          REQUIRED: 'TREASURY.DEDUCTIONS.FORM.FIELDS.PERIODICIDAD.REQUIRED', // La periodicidad es requerida / Frequency is required
          OPTIONS: {
            POR_CUOTA: 'TREASURY.DEDUCTIONS.FORM.FIELDS.PERIODICIDAD.OPTIONS.POR_CUOTA', // Por Cuota / By Installment
            UNICA: 'TREASURY.DEDUCTIONS.FORM.FIELDS.PERIODICIDAD.OPTIONS.UNICA', // Única / One-time
            MENSUAL: 'TREASURY.DEDUCTIONS.FORM.FIELDS.PERIODICIDAD.OPTIONS.MENSUAL', // Mensual / Monthly
            POR_PAGO: 'TREASURY.DEDUCTIONS.FORM.FIELDS.PERIODICIDAD.OPTIONS.POR_PAGO', // Por Pago / By Payment
          },
        },
        NO_CUOTA: {
          LABEL: 'TREASURY.DEDUCTIONS.FORM.FIELDS.NO_CUOTA.LABEL', // No. de Cuota / Installment Number
          TOOLTIP: 'TREASURY.DEDUCTIONS.FORM.FIELDS.NO_CUOTA.TOOLTIP', // Número de cuotas (1-999) / Number of installments (1-999)
          PLACEHOLDER: 'TREASURY.DEDUCTIONS.FORM.FIELDS.NO_CUOTA.PLACEHOLDER', // Ej: 12 / E.g.: 12
          REQUIRED: 'TREASURY.DEDUCTIONS.FORM.FIELDS.NO_CUOTA.REQUIRED', // El número de cuota es requerido / Installment number is required
        },
        FECHA_FINAL: {
          LABEL: 'TREASURY.DEDUCTIONS.FORM.FIELDS.FECHA_FINAL.LABEL', // Fecha Final / End Date
          TOOLTIP: 'TREASURY.DEDUCTIONS.FORM.FIELDS.FECHA_FINAL.TOOLTIP', // Fecha de finalización de la deducción / Deduction end date
          PLACEHOLDER: 'TREASURY.DEDUCTIONS.FORM.FIELDS.FECHA_FINAL.PLACEHOLDER', // dd/MM/yyyy
        },
        TIPO_CALCULO: {
          LABEL: 'TREASURY.DEDUCTIONS.FORM.FIELDS.TIPO_CALCULO.LABEL', // Tipo de Cálculo / Calculation Type
          TOOLTIP: 'TREASURY.DEDUCTIONS.FORM.FIELDS.TIPO_CALCULO.TOOLTIP', // Valor fijo o porcentaje (RN-ALC2-10) / Fixed value or percentage (RN-ALC2-10)
          PLACEHOLDER: 'TREASURY.DEDUCTIONS.FORM.FIELDS.TIPO_CALCULO.PLACEHOLDER', // Seleccionar tipo / Select type
          REQUIRED: 'TREASURY.DEDUCTIONS.FORM.FIELDS.TIPO_CALCULO.REQUIRED', // El tipo de cálculo es requerido / Calculation type is required
          OPTIONS: {
            VALOR: 'TREASURY.DEDUCTIONS.FORM.FIELDS.TIPO_CALCULO.OPTIONS.VALOR', // Valor / Value
            PORCENTAJE: 'TREASURY.DEDUCTIONS.FORM.FIELDS.TIPO_CALCULO.OPTIONS.PORCENTAJE', // % / %
          },
        },
        VALOR_TOTAL_DEDUCIR: {
          LABEL: 'TREASURY.DEDUCTIONS.FORM.FIELDS.VALOR_TOTAL_DEDUCIR.LABEL', // Valor Total a Deducir / Total Amount to Deduct
          TOOLTIP: 'TREASURY.DEDUCTIONS.FORM.FIELDS.VALOR_TOTAL_DEDUCIR.TOOLTIP', // Monto total a deducir (RN-ALC2-11) / Total amount to deduct (RN-ALC2-11)
          PLACEHOLDER: 'TREASURY.DEDUCTIONS.FORM.FIELDS.VALOR_TOTAL_DEDUCIR.PLACEHOLDER', // 0.00
          REQUIRED: 'TREASURY.DEDUCTIONS.FORM.FIELDS.VALOR_TOTAL_DEDUCIR.REQUIRED', // El valor total a deducir es requerido para Crédito y Sanción / Total amount to deduct is required for Credit and Sanction
          MUST_BE_GREATER_THAN_ZERO:
            'TREASURY.DEDUCTIONS.FORM.FIELDS.VALOR_TOTAL_DEDUCIR.MUST_BE_GREATER_THAN_ZERO', // Debe ser mayor a 0 para Crédito y Sanción / Must be greater than 0 for Credit and Sanction
        },
        VALOR_DEDUCIR: {
          LABEL: 'TREASURY.DEDUCTIONS.FORM.FIELDS.VALOR_DEDUCIR.LABEL', // Valor a Deducir / Amount to Deduct
          TOOLTIP: 'TREASURY.DEDUCTIONS.FORM.FIELDS.VALOR_DEDUCIR.TOOLTIP', // Valor por período (editable) / Amount per period (editable)
          PLACEHOLDER: 'TREASURY.DEDUCTIONS.FORM.FIELDS.VALOR_DEDUCIR.PLACEHOLDER', // 0.00
          REQUIRED: 'TREASURY.DEDUCTIONS.FORM.FIELDS.VALOR_DEDUCIR.REQUIRED', // El valor a deducir es requerido / Amount to deduct is required
        },
        PORCENTAJE_DEDUCIR: {
          LABEL: 'TREASURY.DEDUCTIONS.FORM.FIELDS.PORCENTAJE_DEDUCIR.LABEL', // % a Deducir / % to Deduct
          TOOLTIP: 'TREASURY.DEDUCTIONS.FORM.FIELDS.PORCENTAJE_DEDUCIR.TOOLTIP', // Porcentaje a deducir (0.01 - 100) / Percentage to deduct (0.01 - 100)
          PLACEHOLDER: 'TREASURY.DEDUCTIONS.FORM.FIELDS.PORCENTAJE_DEDUCIR.PLACEHOLDER', // 5.00
          REQUIRED: 'TREASURY.DEDUCTIONS.FORM.FIELDS.PORCENTAJE_DEDUCIR.REQUIRED', // El porcentaje a deducir es requerido / Percentage to deduct is required
        },
        ACREEDOR: {
          LABEL: 'TREASURY.DEDUCTIONS.FORM.FIELDS.ACREEDOR.LABEL', // ID Acreedor / Creditor ID
          TOOLTIP: 'TREASURY.DEDUCTIONS.FORM.FIELDS.ACREEDOR.TOOLTIP', // Máximo 12 dígitos / Maximum 12 digits
          PLACEHOLDER: 'TREASURY.DEDUCTIONS.FORM.FIELDS.ACREEDOR.PLACEHOLDER', // Seleccione el acreedor / Select the creditor
          REQUIRED: 'TREASURY.DEDUCTIONS.FORM.FIELDS.ACREEDOR.REQUIRED', // El acreedor es requerido / Creditor is required
          SEARCH_TOOLTIP: 'TREASURY.DEDUCTIONS.FORM.FIELDS.ACREEDOR.SEARCH_TOOLTIP', // Buscar acreedor / Search creditor
        },
        NOMBRE_ACREEDOR: {
          LABEL: 'TREASURY.DEDUCTIONS.FORM.FIELDS.NOMBRE_ACREEDOR.LABEL', // Nombre Acreedor / Creditor Name
          TOOLTIP: 'TREASURY.DEDUCTIONS.FORM.FIELDS.NOMBRE_ACREEDOR.TOOLTIP', // Se autocompleta al seleccionar el ID Acreedor / Auto-completes when selecting Creditor ID
          PLACEHOLDER: 'TREASURY.DEDUCTIONS.FORM.FIELDS.NOMBRE_ACREEDOR.PLACEHOLDER', // Se autocompleta / Auto-completes
        },
        CUENTA_CONTABLE: {
          LABEL: 'TREASURY.DEDUCTIONS.FORM.FIELDS.CUENTA_CONTABLE.LABEL', // Cód. Cuenta Contable / Accounting Account Code
          TOOLTIP: 'TREASURY.DEDUCTIONS.FORM.FIELDS.CUENTA_CONTABLE.TOOLTIP', // Cuenta de movimiento  / Movement account
          PLACEHOLDER: 'TREASURY.DEDUCTIONS.FORM.FIELDS.CUENTA_CONTABLE.PLACEHOLDER', // Seleccione la cuenta / Select the account
          REQUIRED: 'TREASURY.DEDUCTIONS.FORM.FIELDS.CUENTA_CONTABLE.REQUIRED', // La cuenta contable es requerida / Accounting account is required
          SEARCH_TOOLTIP: 'TREASURY.DEDUCTIONS.FORM.FIELDS.CUENTA_CONTABLE.SEARCH_TOOLTIP', // Buscar cuenta contable / Search accounting account
          NOT_FOUND: 'TREASURY.DEDUCTIONS.FORM.FIELDS.CUENTA_CONTABLE.NOT_FOUND', // Cuenta no existe o no es de movimiento / Account does not exist or is not a movement account
        },
        ESTADO: {
          LABEL: 'TREASURY.DEDUCTIONS.FORM.FIELDS.ESTADO.LABEL', // Estado / Status
          TOOLTIP: 'TREASURY.DEDUCTIONS.FORM.FIELDS.ESTADO.TOOLTIP', // Activo o Inactivo / Active or Inactive
          PLACEHOLDER: 'TREASURY.DEDUCTIONS.FORM.FIELDS.ESTADO.PLACEHOLDER', // Seleccionar estado / Select status
          REQUIRED: 'TREASURY.DEDUCTIONS.FORM.FIELDS.ESTADO.REQUIRED', // El estado es requerido / Status is required
          OPTIONS: {
            ACTIVO: 'TREASURY.DEDUCTIONS.FORM.FIELDS.ESTADO.OPTIONS.ACTIVO', // Activo / Active
            INACTIVO: 'TREASURY.DEDUCTIONS.FORM.FIELDS.ESTADO.OPTIONS.INACTIVO', // Inactivo / Inactive
          },
        },
        VALOR_TOTAL_DEDUCIDO: {
          LABEL: 'TREASURY.DEDUCTIONS.FORM.FIELDS.VALOR_TOTAL_DEDUCIDO.LABEL', // Valor Total Deducido / Total Deducted Amount
          TOOLTIP: 'TREASURY.DEDUCTIONS.FORM.FIELDS.VALOR_TOTAL_DEDUCIDO.TOOLTIP', // Suma de egresos aplicados / Sum of applied expenses
        },
        SALDO_POR_DEDUCIR: {
          LABEL: 'TREASURY.DEDUCTIONS.FORM.FIELDS.SALDO_POR_DEDUCIR.LABEL', // Saldo Por Deducir / Balance to Deduct
          TOOLTIP: 'TREASURY.DEDUCTIONS.FORM.FIELDS.SALDO_POR_DEDUCIR.TOOLTIP', // Saldo pendiente / Pending balance
        },
        FECHA_FINALIZACION: {
          LABEL: 'TREASURY.DEDUCTIONS.FORM.FIELDS.FECHA_FINALIZACION.LABEL', // Fecha Finalización / Finalization Date
          TOOLTIP: 'TREASURY.DEDUCTIONS.FORM.FIELDS.FECHA_FINALIZACION.TOOLTIP', // Fecha en que se finaliza la deducción / Date when the deduction is finalized
          REQUIRED: 'TREASURY.DEDUCTIONS.FORM.FIELDS.FECHA_FINALIZACION.REQUIRED', // La fecha de finalización es requerida / Finalization date is required
        },
        MOTIVO_FINALIZACION: {
          LABEL: 'TREASURY.DEDUCTIONS.FORM.FIELDS.MOTIVO_FINALIZACION.LABEL', // Motivo Finalización / Finalization Reason
          TOOLTIP: 'TREASURY.DEDUCTIONS.FORM.FIELDS.MOTIVO_FINALIZACION.TOOLTIP', // Motivo por el cual se finaliza la deducción / Reason why the deduction is finalized
          PLACEHOLDER: 'TREASURY.DEDUCTIONS.FORM.FIELDS.MOTIVO_FINALIZACION.PLACEHOLDER', // Seleccionar motivo / Select reason
          REQUIRED: 'TREASURY.DEDUCTIONS.FORM.FIELDS.MOTIVO_FINALIZACION.REQUIRED', // El motivo de finalización es requerido / Finalization reason is required
          OPTIONS: {
            PAGO_TOTAL: 'TREASURY.DEDUCTIONS.FORM.FIELDS.MOTIVO_FINALIZACION.OPTIONS.PAGO_TOTAL', // Pago total / Total payment
            CANCELACION_ANTICIPADA:
              'TREASURY.DEDUCTIONS.FORM.FIELDS.MOTIVO_FINALIZACION.OPTIONS.CANCELACION_ANTICIPADA', // Cancelación anticipada / Early cancellation
            AJUSTE_POR_ENTIDAD:
              'TREASURY.DEDUCTIONS.FORM.FIELDS.MOTIVO_FINALIZACION.OPTIONS.AJUSTE_POR_ENTIDAD', // Ajuste por entidad / Entity adjustment
            ERROR_EN_REGISTRO:
              'TREASURY.DEDUCTIONS.FORM.FIELDS.MOTIVO_FINALIZACION.OPTIONS.ERROR_EN_REGISTRO', // Error en registro / Registration error
            RETIRO_DEL_TRABAJADOR:
              'TREASURY.DEDUCTIONS.FORM.FIELDS.MOTIVO_FINALIZACION.OPTIONS.RETIRO_DEL_TRABAJADOR', // Retiro del trabajador / Worker withdrawal
          },
        },
      },

      VALIDATIONS: {
        REQUIRED_FIELD: 'TREASURY.DEDUCTIONS.FORM.VALIDATIONS.REQUIRED_FIELD', // Campo requerido / This field is required
        MAX_LENGTH: 'TREASURY.DEDUCTIONS.FORM.VALIDATIONS.MAX_LENGTH', // Máximo {max} caracteres / Maximum {max} characters
        MUST_BE_GREATER_THAN: 'TREASURY.DEDUCTIONS.FORM.VALIDATIONS.MUST_BE_GREATER_THAN', // Debe ser mayor a {min} / Must be greater than {min}
        FECHA_MENOR_MES_CERRADO: 'TREASURY.DEDUCTIONS.FORM.VALIDATIONS.FECHA_MENOR_MES_CERRADO', // No puede ser menor al mes cerrado / Cannot be earlier than the closed month
        FECHA_FINAL_MENOR_UN_MES: 'TREASURY.DEDUCTIONS.FORM.VALIDATIONS.FECHA_FINAL_MENOR_UN_MES', // Debe ser al menos un mes superior / Must be at least one month later
        CUOTA_MAYOR_CERO: 'TREASURY.DEDUCTIONS.FORM.VALIDATIONS.CUOTA_MAYOR_CERO', // Debe ser >0 / Must be >0
        CUOTA_VALID_RANGE: 'TREASURY.DEDUCTIONS.FORM.VALIDATIONS.CUOTA_VALID_RANGE', // Número de cuotas válido (1-999) / Valid installment number (1-999)
        PORCENTAJE_VALID_RANGE: 'TREASURY.DEDUCTIONS.FORM.VALIDATIONS.PORCENTAJE_VALID_RANGE', // Porcentaje debe estar entre 0.01 y 100 / Percentage must be between 0.01 and 100
        DOCUMENTO_UNIQUE: 'TREASURY.DEDUCTIONS.FORM.VALIDATIONS.DOCUMENTO_UNIQUE', // El documento ya existe para este deudor / Document already exists for this debtor
        FECHA_FINALIZACION_FUTURA: 'TREASURY.DEDUCTIONS.FORM.VALIDATIONS.FECHA_FINALIZACION_FUTURA',
      },
    },

    MODALS: {
      DEUDOR: {
        TITLE: 'TREASURY.DEDUCTIONS.MODALS.DEUDOR.TITLE', // Seleccionar Deudor / Select Debtor
      },
      ACREEDOR: {
        TITLE: 'TREASURY.DEDUCTIONS.MODALS.ACREEDOR.TITLE', // Seleccionar Acreedor / Select Creditor
      },
      CUENTA_CONTABLE: {
        TITLE: 'TREASURY.DEDUCTIONS.MODALS.CUENTA_CONTABLE.TITLE', // Seleccionar Cuenta Contable / Select Accounting Account
      },
    },

    ALERTS: {
      LOAD_ERROR: {
        TITLE: 'TREASURY.DEDUCTIONS.ALERTS.LOAD_ERROR.TITLE', // Error al cargar datos / Error loading data
        MESSAGE: 'TREASURY.DEDUCTIONS.ALERTS.LOAD_ERROR.MESSAGE', // Ocurrió un error al cargar los datos / An error occurred while loading data
      },
      SAVE_SUCCESS: {
        TITLE: 'TREASURY.DEDUCTIONS.ALERTS.SAVE_SUCCESS.TITLE', // Deducción guardada / Deduction saved
        MESSAGE: 'TREASURY.DEDUCTIONS.ALERTS.SAVE_SUCCESS.MESSAGE', // La deducción ha sido guardada exitosamente / The deduction has been saved successfully
      },
      SAVE_ERROR: {
        TITLE: 'TREASURY.DEDUCTIONS.ALERTS.SAVE_ERROR.TITLE', // Error al guardar / Error saving
        MESSAGE: 'TREASURY.DEDUCTIONS.ALERTS.SAVE_ERROR.MESSAGE', // Ocurrió un error al guardar la deducción / An error occurred while saving the deduction
      },
      UPDATE_SUCCESS: {
        TITLE: 'TREASURY.DEDUCTIONS.ALERTS.UPDATE_SUCCESS.TITLE', // Deducción actualizada / Deduction updated
        MESSAGE: 'TREASURY.DEDUCTIONS.ALERTS.UPDATE_SUCCESS.MESSAGE', // La deducción ha sido actualizada exitosamente / The deduction has been updated successfully
      },
      UPDATE_ERROR: {
        TITLE: 'TREASURY.DEDUCTIONS.ALERTS.UPDATE_ERROR.TITLE', // Error al actualizar / Error updating
        MESSAGE: 'TREASURY.DEDUCTIONS.ALERTS.UPDATE_ERROR.MESSAGE', // Ocurrió un error al actualizar la deducción / An error occurred while updating the deduction
      },
      DELETE_SUCCESS: {
        TITLE: 'TREASURY.DEDUCTIONS.ALERTS.DELETE_SUCCESS.TITLE', // Deducción eliminada / Deduction deleted
        MESSAGE: 'TREASURY.DEDUCTIONS.ALERTS.DELETE_SUCCESS.MESSAGE', // La deducción ha sido eliminada exitosamente / The deduction has been deleted successfully
      },
      DELETE_ERROR: {
        TITLE: 'TREASURY.DEDUCTIONS.ALERTS.DELETE_ERROR.TITLE', // Error al eliminar / Error deleting
        MESSAGE: 'TREASURY.DEDUCTIONS.ALERTS.DELETE_ERROR.MESSAGE', // Ocurrió un error al eliminar la deducción / An error occurred while deleting the deduction
      },
      FINALIZE_SUCCESS: {
        TITLE: 'TREASURY.DEDUCTIONS.ALERTS.FINALIZE_SUCCESS.TITLE', // Deducción finalizada / Deduction finalized
        MESSAGE: 'TREASURY.DEDUCTIONS.ALERTS.FINALIZE_SUCCESS.MESSAGE', // La deducción ha sido finalizada exitosamente / The deduction has been finalized successfully
      },
      FINALIZE_ERROR: {
        TITLE: 'TREASURY.DEDUCTIONS.ALERTS.FINALIZE_ERROR.TITLE', // Error al finalizar / Error finalizing
        MESSAGE: 'TREASURY.DEDUCTIONS.ALERTS.FINALIZE_ERROR.MESSAGE', // Ocurrió un error al finalizar la deducción / An error occurred while finalizing the deduction
      },
      SELECTION_SUCCESS: {
        TITLE: 'TREASURY.DEDUCTIONS.ALERTS.SELECTION_SUCCESS.TITLE', // Selección exitosa / Selection successful
        MESSAGE: 'TREASURY.DEDUCTIONS.ALERTS.SELECTION_SUCCESS.MESSAGE', // {type} seleccionado: {value} / {type} selected: {value}
      },
      SELECTION_ERROR: {
        TITLE: 'TREASURY.DEDUCTIONS.ALERTS.SELECTION_ERROR.TITLE', // Error en la selección / Selection error
        MESSAGE: 'TREASURY.DEDUCTIONS.ALERTS.SELECTION_ERROR.MESSAGE', // {type} no existe o no está activo / {type} does not exist or is not active
      },
      PERMISSION_ERROR: {
        TITLE: 'TREASURY.DEDUCTIONS.ALERTS.PERMISSION_ERROR.TITLE', // Permiso denegado / Permission denied
        EDIT_DENIED: 'TREASURY.DEDUCTIONS.ALERTS.PERMISSION_ERROR.EDIT_DENIED', // Solo se puede editar una deducción en estado Activo o Inactivo (RN-ALC1-08) / Only a deduction in Active or Inactive status can be edited (RN-ALC1-08)
        FINALIZE_DENIED: 'TREASURY.DEDUCTIONS.ALERTS.PERMISSION_ERROR.FINALIZE_DENIED', // Solo se puede finalizar una deducción Activa o Inactiva (RN-ALC1-08) / Only an Active or Inactive deduction can be finalized (RN-ALC1-08)
        DELETE_DENIED: 'TREASURY.DEDUCTIONS.ALERTS.PERMISSION_ERROR.DELETE_DENIED', // Solo se puede eliminar una deducción Inactiva y sin egresos asociados (RN-ALC5-01/02) / Only an Inactive deduction with no associated expenses can be deleted (RN-ALC5-01/02)
      },
    },

    CONFIRM_DIALOGS: {
      CANCEL: {
        TITLE: 'TREASURY.DEDUCTIONS.CONFIRM_DIALOGS.CANCEL.TITLE', // Cancelar cambios / Cancel changes
        MESSAGE: 'TREASURY.DEDUCTIONS.CONFIRM_DIALOGS.CANCEL.MESSAGE', // ¿Está seguro de que desea cancelar los cambios? Se perderán todas las modificaciones no guardadas. / Are you sure you want to cancel the changes? All unsaved modifications will be lost.
        CONFIRM_LABEL: 'TREASURY.DEDUCTIONS.CONFIRM_DIALOGS.CANCEL.CONFIRM_LABEL', // Sí, cancelar / Yes, cancel
        CANCEL_LABEL: 'TREASURY.DEDUCTIONS.CONFIRM_DIALOGS.CANCEL.CANCEL_LABEL', // Continuar editando / Continue editing
      },
      DELETE: {
        TITLE: 'TREASURY.DEDUCTIONS.CONFIRM_DIALOGS.DELETE.TITLE', // Eliminar deducción / Delete deduction
        MESSAGE: 'TREASURY.DEDUCTIONS.CONFIRM_DIALOGS.DELETE.MESSAGE', // Se va a eliminar la deducción {consecutivo} (MSG-18)\n¿Está seguro? / The deduction {consecutivo} is going to be deleted (MSG-18)\nAre you sure?
        CONFIRM_LABEL: 'TREASURY.DEDUCTIONS.CONFIRM_DIALOGS.DELETE.CONFIRM_LABEL', // Sí, eliminar / Yes, delete
        CANCEL_LABEL: 'ACTIONS.CANCEL', // Cancelar / Cancel (common_keys)
      },
      FINALIZE: {
        TITLE: 'TREASURY.DEDUCTIONS.CONFIRM_DIALOGS.FINALIZE.TITLE', // Confirmar finalización / Confirm finalization
        MESSAGE: 'TREASURY.DEDUCTIONS.CONFIRM_DIALOGS.FINALIZE.MESSAGE', // ¿Está seguro que desea finalizar la deducción {consecutivo}? / Are you sure you want to finalize deduction {consecutivo}?
        CONFIRM_LABEL: 'TREASURY.DEDUCTIONS.CONFIRM_DIALOGS.FINALIZE.CONFIRM_LABEL', // Finalizar / Finalize
        CANCEL_LABEL: 'ACTIONS.CANCEL', // Cancelar / Cancel (common_keys)
      },
    },

    ACTIONS: {
      CREATE: 'ACTIONS.CREATE', // Crear / Create (common / abstract CRUD)
      REFRESH: 'ACTIONS.REFRESH', // Refrescar / Refresh
      CANCEL: 'ACTIONS.CANCEL', // Cancelar / Cancel
      SAVE: 'ACTIONS.SAVE', // Guardar / Save
      SAVING: 'ACTIONS.SAVING', // Guardando... / Saving... (common_keys)
      FINALIZE: 'TREASURY.DEDUCTIONS.ACTIONS.FINALIZE', // Finalizar / Finalize (específico HU)
      FINALIZING: 'TREASURY.DEDUCTIONS.ACTIONS.FINALIZING', // Finalizando... / Finalizing...
      DELETE: 'ACTIONS.DELETE', // Eliminar / Delete (common_keys)
      EDIT: 'ACTIONS.EDIT', // Editar / Edit (common_keys)
      VIEW: 'ACTIONS.VIEW', // Consultar / View (common_keys)
    },

    ERROR_MESSAGES: {
      REQUIRED_FIELD: 'TREASURY.DEDUCTIONS.ERROR_MESSAGES.REQUIRED_FIELD', // Campo requerido / This field is required
      INVALID_FORM: 'TREASURY.DEDUCTIONS.ERROR_MESSAGES.INVALID_FORM', // Existen campos obligatorios por diligenciar (MSG-14) / There are required fields to fill (MSG-14)
      VALOR_TOTAL_INVALID: 'TREASURY.DEDUCTIONS.ERROR_MESSAGES.VALOR_TOTAL_INVALID', // Valor Total a Deducir debe ser mayor a 0 para Crédito y Sanción / Total Amount to Deduct must be greater than 0 for Credit and Sanction
      DOCUMENTO_EXISTS: 'TREASURY.DEDUCTIONS.ERROR_MESSAGES.DOCUMENTO_EXISTS', // El documento ya existe para este deudor / The document already exists for this debtor
    },

    INFO_MESSAGES: {
      DEUDOR_SELECTED: 'TREASURY.DEDUCTIONS.INFO_MESSAGES.DEUDOR_SELECTED', // Deudor seleccionado: {value} / Debtor selected: {value}
      ACREEDOR_SELECTED: 'TREASURY.DEDUCTIONS.INFO_MESSAGES.ACREEDOR_SELECTED', // Acreedor seleccionado: {value} / Creditor selected: {value}
      CUENTA_SELECTED: 'TREASURY.DEDUCTIONS.INFO_MESSAGES.CUENTA_SELECTED', // Cuenta contable seleccionada: {value} / Accounting account selected: {value}
    },

    BADGE: {
      VARIANTS: {
        ACTIVO: 'TREASURY.DEDUCTIONS.BADGE.VARIANTS.ACTIVO', // success
        INACTIVO: 'TREASURY.DEDUCTIONS.BADGE.VARIANTS.INACTIVO', // warning
        FINALIZADO: 'TREASURY.DEDUCTIONS.BADGE.VARIANTS.FINALIZADO', // neutral
      },
    },
  },
  EXPENSES: {
    COUNTER: {
      LABEL_SINGULAR: 'TREASURY.EXPENSES.COUNTER.LABEL_SINGULAR', // Comprobante de egreso
      LABEL_PLURAL: 'TREASURY.EXPENSES.COUNTER.LABEL_PLURAL', // Comprobantes de egreso
    },

    EMPTY: {
      MESSAGE: 'TREASURY.EXPENSES.EMPTY.MESSAGE', // No hay comprobantes de egreso para mostrar
      PAYMENT_ORDERS: {
        MESSAGE: 'TREASURY.PAYMENT_ANNULMENT.EMPTY.PAYMENT_ORDERS',
        DESCRIPTION: 'TREASURY.PAYMENT_ANNULMENT.EMPTY.PAYMENT_ORDERS_DESC',
      },
      STATUS_HISTORY: {
        MESSAGE: 'TREASURY.PAYMENT_ANNULMENT.EMPTY.STATUS_LOG',
        DESCRIPTION: 'TREASURY.PAYMENT_ANNULMENT.EMPTY.STATUS_LOG_DESC',
      },
      DETAILS: {
        MESSAGE: 'TREASURY.EXPENSE.EMPTY.DETAILS', //No hay Detalles
        DESCRIPTION: 'TREASURY.EXPENSE.EMPTY.DETAILS_DESC', //Este comprobante no tiene detalles registrados
      },
    },
    TITLE: {
      LIST: 'TREASURY.EXPENSES.TITLE.LIST', // Comprobantes de egreso
      CREATE: 'TREASURY.EXPENSES.TITLE.CREATE', // Crear comprobante de egreso
      VIEW: 'TREASURY.EXPENSES.TITLE.VIEW', // Consultar comprobante de egreso
    },
    SUBTITLE: {
      LIST: 'TREASURY.EXPENSES.SUBTITLE.LIST', // Gestión de comprobantes de egreso
      CREATE: 'TREASURY.EXPENSES.SUBTITLE.CREATE', // Registre la información del comprobante de egreso
      VIEW: 'TREASURY.EXPENSES.SUBTITLE.VIEW', // Consulte la información del comprobante de egreso
    },
    COLUMNS: {
      EXPENSE_TYPE: 'TREASURY.EXPENSES.COLUMNS.EXPENSE_TYPE', // Tipo de egreso
      SEQUENCE: 'TREASURY.EXPENSES.COLUMNS.SEQUENCE', // Consecutivo
      IDENTIFICATION_NUMBER: 'TREASURY.PARAMETERS.FIELDS.IDENTIFICATION.LABEL', // No. Identificación
      NAME_OR_BUSINESS_NAME:
        'ACCOUNTING.ENTRY_DEFERRED.DEFERRED_MONTH_TABLE.COLUMN.NAME_OR_BUSINESS_NAME', // Nombre o razón social
      EXPENSE_DATE: 'TREASURY.EXPENSES.COLUMNS.EXPENSE_DATE', // Fecha del comprobante de egreso
      PAYMENT_DATE: 'TREASURY.EXPENSES.COLUMNS.PAYMENT_DATE', // Fecha de pago
      TOTAL_AMOUNT: 'ACCOUNTING.CAUSACION.COLUMNS_NAMES.VALOR_TOTAL', // Valor total
    },
    LABEL: {
      EXPENSE_TYPE: 'TREASURY.EXPENSES.LABEL.EXPENSE_TYPE', // Tipo de egreso
      ENTRY_TYPE: 'TREASURY.INCOME.HEADER.TIPO_ASIENTO.LABEL', // Tipo de asiento
      BENEFICIARY_IS_OTHER_THIRD_PARTY: 'TREASURY.EXPENSES.LABEL.BENEFICIARY_IS_OTHER_THIRD_PARTY', // ¿El beneficiario es otro tercero?
      BENEFICIARY_IDENTIFICATION: 'TREASURY.EXPENSES.LABEL.BENEFICIARY_IDENTIFICATION', // No. identificación del beneficiario
      BENEFICIARY_NAME: 'TREASURY.EXPENSES.LABEL.BENEFICIARY_NAME', // Nombre del beneficiario
      CREATED_BY: 'TREASURY.EXPENSES.LABEL.CREATED_BY', // Elaboró
      APPROVED_BY: 'TREASURY.EXPENSES.LABEL.APPROVED_BY', // Aprobó
      MONTH: 'ACCOUNTING.ENTRY_DEFERRED.LABEL.MES', // Mes
      VALIDITY: 'PLACEHOLDER.VALIDITY', // Vigencia
      MUNICIPALITY: 'OPTIONS.MUNICIPALITY', // Municipio
      ACCOUNT_OD: 'TREASURY.EXPENSES.LABEL.ACCOUNT_OD', // Cód. cuenta (OD)
    },

    PLACEHOLDER: {
      EXPENSE_TYPE: 'TREASURY.EXPENSES.PLACEHOLDER.EXPENSE_TYPE', // Seleccione el tipo de egreso
      BENEFICIARY_IS_OTHER_THIRD_PARTY:
        'TREASURY.EXPENSES.PLACEHOLDER.BENEFICIARY_IS_OTHER_THIRD_PARTY', // Seleccione una opción
      ENTRY_TYPE: 'TREASURY.INCOME.HEADER.TIPO_ASIENTO.PLACEHOLDER', // Seleccione el tipo de asiento
    },
    TOOLTIP: {
      BENEFICIARY_IDENTIFICATION: 'TREASURY.EXPENSES.TOOLTIP.BENEFICIARY_IDENTIFICATION', // Identificación del tercero que recibirá el pago
      BENEFICIARY_NAME: 'TREASURY.EXPENSES.TOOLTIP.BENEFICIARY_NAME', // Nombre o razón social del beneficiario
      BENEFICIARY_IS_OTHER_THIRD_PARTY:
        'TREASURY.EXPENSES.TOOLTIP.BENEFICIARY_IS_OTHER_THIRD_PARTY', // Indique si el pago se realizará a un tercero diferente
      CONCEPT: 'TREASURY.EXPENSES.TOOLTIP.CONCEPT', // Concepto configurado en parámetros de tesorería
      EXPENSE_TYPE: 'TREASURY.EXPENSES.TOOLTIP.EXPENSE_TYPE', // Seleccione el tipo de comprobante de egreso
      ENTRY_TYPE: 'TREASURY.EXPENSES.TOOLTIP.ENTRY_TYPE', // Tipos de asiento asociados al concepto
      DEDUCTIONS_TYPE: 'TREASURY.EXPENSES.TOOLTIP.DEDUCTIONS_TYPE', // Tipo de deducción aplicable al comprobante
      MONTH: 'TREASURY.EXPENSES.TOOLTIP.MONTH', // Mes al que corresponde la deducción
      VALIDITY: 'TREASURY.EXPENSES.TOOLTIP.VALIDITY', // Mes al que corresponde la deducción
      MUNICIPALITY: 'TREASURY.EXPENSES.TOOLTIP.MUNICIPALITY', // Municipio asociado a la deducción
      ACCOUNT_OD: 'TREASURY.EXPENSES.TOOLTIP.ACCOUNT_OD', // Código de la cuenta OD asociada
      ACCOUNT_OD_NAME: 'TREASURY.EXPENSES.TOOLTIP.ACCOUNT_OD_NAME', // Nombre de la cuenta OD asociada
      CREATED_BY: 'TREASURY.EXPENSES.TOOLTIP.CREATED_BY', // Usuario que elaboró el comprobante
      APPROVED_BY: 'TREASURY.EXPENSES.TOOLTIP.APPROVED_BY', // Usuario responsable de aprobar el comprobante
      TOTAL_AMOUNT: 'TREASURY.EXPENSES.TOOLTIP.TOTAL_AMOUNT', // Valor total del comprobante de egreso
      DESCRIPTION: 'TREASURY.EXPENSES.TOOLTIP.DESCRIPTION', // Descripción del detalle contable
    },
    TYPE: {
      WITH_PO: 'TREASURY.EXPENSES.TYPE.WITH_PO', // Egreso con orden de pago
      WITHOUT_PO: 'TREASURY.EXPENSES.TYPE.WITHOUT_PO', // Egreso sin orden de pago
      DEDUCTIONS: 'TREASURY.EXPENSES.TYPE.DEDUCTIONS', // Deducciones
      EMBARGOES: 'TREASURY.EXPENSES.TYPE.EMBARGOES', // Embargos
    },
    STATUS: {
      FOR_PAYMENT: 'TREASURY.EXPENSES.STATUS.FOR_PAYMENT', // Para pago
      TO_BE_SCHEDULED: 'TREASURY.EXPENSES.STATUS.TO_BE_SCHEDULED', // Por programar
      ISSUED: 'TREASURY.EXPENSES.STATUS.ISSUED', // Emitido
      TO_TRANSFER: 'TREASURY.EXPENSES.STATUS.TO_TRANSFER', // Por transferir
      TRANSFERRED: 'TREASURY.EXPENSES.STATUS.TRANSFERRED', // Transferido
      CONFIRMED: 'TREASURY.EXPENSES.STATUS.CONFIRMED', // Confirmado
      CANCELED: 'TREASURY.EXPENSES.STATUS.CANCELED', // Anulado
      REJECTED: 'TREASURY.EXPENSES.STATUS.REJECTED', // Rechazado
    },
    SECTION: {
      HEADER: 'TREASURY.EXPENSES.SECTION.HEADER', // Encabezado
      GENERAL: 'ACCOUNTING.THIRD_PARTY.FORM.GENERAL_DATA', // General
      THIRD_PARTY_DATA: 'TREASURY.EXPENSES.SECTION.THIRD_PARTY_DATA', // Datos del tercero
      ACCOUNT_DETAILS: 'TREASURY.EXPENSES.SECTION.ACCOUNT_DETAILS', // Detalle de cuentas
      BUDGET_INFORMATION: 'TREASURY.EXPENSES.SECTION.BUDGET_INFORMATION', // Información presupuestal
      APPROVAL_AND_ACTIONS: 'TREASURY.EXPENSES.SECTION.APPROVAL_AND_ACTIONS', // Aprobación y acciones
      DEDUCTION_SETTINGS: 'TREASURY.EXPENSES.SECTION.TITLE.DEDUCTION_SETTINGS', // Parámetros de deducción
      STATUS_HISTORY: 'TREASURY.EXPENSES.TAB.STATUS_LOG', // Bitácora de estados
      SUBTITLE: {
        GENERAL: 'ACCOUNTING.THIRD_PARTY.FORM.GENERAL_DATA', // Configuración general del comprobante.
        THIRD_PARTY_DATA: 'TREASURY.EXPENSES.SECTION.SUBTITLE.THIRD_PARTY_DATA', // Identifique el tercero relacionado con el comprobante.
        ACCOUNT_DETAILS: 'TREASURY.EXPENSES.SECTION.SUBTITLE.ACCOUNT_DETAILS', // Configure las cuentas contables y los valores asociados al comprobante.
        BUDGET_INFORMATION: 'TREASURY.EXPENSES.SECTION.SUBTITLE.BUDGET_INFORMATION', // Registre la información presupuestal asociada al comprobante.
        APPROVAL_AND_ACTIONS: 'TREASURY.EXPENSES.SECTION.SUBTITLE.APPROVAL_AND_ACTIONS', // Gestione la aprobación y las acciones disponibles para el comprobante.
        PAYMENT_ORDER: 'TREASURY.EXPENSES.SECTION.SUBTITLE.PAYMENT_ORDER', // Seleccione la orden de pago y registre la información correspondiente al beneficiario y los valores a pagar.
        DEDUCTION_SETTINGS: 'TREASURY.EXPENSES.SECTION.SUBTITLE.DEDUCTION_SETTINGS', // Configure los parámetros y valores aplicables a las deducciones del comprobante.
        STATUS_HISTORY: 'TREASURY.EXPENSES.TAB.SUBTITLE.STATUS_LOG', //  Historial de cambios de estado del comprobante
      },
    },
    MODAL: {
      ACCOUNTS: {
        TITLE: 'TREASURY.EXPENSES.MODAL.ACCOUNTS_TITLE', // Seleccione una cuenta OD
      },
    },
    TABLE: {
      COLUMNS: {
        PAYMENT_ORDER_BALANCE: 'TREASURY.EXPENSES.TABLE.COLUMNS.PAYMENT_ORDER_BALANCE', // Saldo de la orden de pago
        PAID_AMOUNT: 'TREASURY.EXPENSES.TABLE.COLUMNS.PAID_AMOUNT', // Valor pagado en el comprobante de egreso
      },
    },
    STATUS_LOG: {
      DATE_TIME: 'TREASURY.EXPENSES.STATUS_LOG.DATE_TIME', // Fecha y hora
      USER: 'TREASURY.EXPENSES.STATUS_LOG.USER', // Usuario
      PREVIOUS_STATUS: 'TREASURY.EXPENSES.STATUS_LOG.PREVIOUS_STATUS', // Estado anterior
      NEW_STATUS: 'TREASURY.EXPENSES.STATUS_LOG.NEW_STATUS', // Estado nuevo
      OBSERVATIONS: 'TREASURY.EXPENSES.STATUS_LOG.OBSERVATIONS', // Observaciones
    },
  },

  INCOME: {
    // ==================== TÍTULOS DE PÁGINA ====================
    TITLE: {
      LIST: 'TREASURY.INCOME.TITLE.LIST',
      CREATE: 'TREASURY.INCOME.TITLE.CREATE',
      EDIT: 'TREASURY.INCOME.TITLE.EDIT',
      VIEW: 'TREASURY.INCOME.TITLE.VIEW',
      SUBTITLE: {
        LIST: 'TREASURY.INCOME.TITLE.SUBTITLE.LIST',
        CREATE: 'TREASURY.INCOME.TITLE.SUBTITLE.CREATE',
        EDIT: 'TREASURY.INCOME.TITLE.SUBTITLE.EDIT',
        VIEW: 'TREASURY.INCOME.TITLE.SUBTITLE.VIEW',
      },
    },

    // ==================== CONTADOR DE RESULTADOS ====================
    RESULTS_COUNTER: {
      SINGULAR: 'TREASURY.INCOME.RESULTS_COUNTER.SINGULAR',
      PLURAL: 'TREASURY.INCOME.RESULTS_COUNTER.PLURAL',
    },

    // ==================== FILTROS (FN-ALC1-02) ====================
    FILTERS: {
      SEARCH: {
        PLACEHOLDER: 'TREASURY.INCOME.FILTERS.SEARCH.PLACEHOLDER',
      },
      DATE_RANGE: {
        START_LABEL: 'TREASURY.INCOME.FILTERS.DATE_RANGE.START_LABEL',
        END_LABEL: 'TREASURY.INCOME.FILTERS.DATE_RANGE.END_LABEL',
        PLACEHOLDER: 'TREASURY.INCOME.FILTERS.DATE_RANGE.PLACEHOLDER',
      },
      ESTADO: {
        LABEL: 'TREASURY.INCOME.FILTERS.ESTADO.LABEL',
        PLACEHOLDER: 'TREASURY.INCOME.FILTERS.ESTADO.PLACEHOLDER',
        OPTIONS: {
          APROBADO: 'TREASURY.INCOME.FILTERS.ESTADO.OPTIONS.APROBADO',
          PENDIENTE: 'TREASURY.INCOME.FILTERS.ESTADO.OPTIONS.PENDIENTE',
          RECHAZADO: 'TREASURY.INCOME.FILTERS.ESTADO.OPTIONS.RECHAZADO',
        },
      },
    },

    // ==================== TABLA (FN-ALC1-04) ====================
    TABLE: {
      COLUMNS: {
        CONSECUTIVO: 'TREASURY.INCOME.TABLE.COLUMNS.CONSECUTIVO',
        IDENTIFICACION: 'TREASURY.INCOME.TABLE.COLUMNS.IDENTIFICACION',
        NOMBRE: 'TREASURY.INCOME.TABLE.COLUMNS.NOMBRE',
        FECHA_INGRESO: 'TREASURY.INCOME.TABLE.COLUMNS.FECHA_INGRESO',
        VALOR_TOTAL: 'TREASURY.INCOME.TABLE.COLUMNS.VALOR_TOTAL',
        ESTADO: 'TREASURY.INCOME.TABLE.COLUMNS.ESTADO',
      },
      ACTIONS: {
        LABEL: 'COMMON.ACTIONS',
        VIEW: 'ACTIONS.VIEW',
        EDIT: 'ACTIONS.EDIT',
        DELETE: 'ACTIONS.DELETE',
      },
      EMPTY: {
        MESSAGE: 'TREASURY.INCOME.TABLE.EMPTY.MESSAGE',
        DESCRIPTION: 'TREASURY.INCOME.TABLE.EMPTY.DESCRIPTION',
      },
    },

    // ==================== FORMULARIO (FN-ALC2) ====================
    FORM: {
      // ----- Encabezado del comprobante (FN-ALC2-01) -----
      HEADER: {
        TITLE: 'TREASURY.INCOME.TITLE.HEADER',

        CONSECUTIVO: {
          LABEL: 'TREASURY.INCOME.HEADER.CONSECUTIVO.LABEL',
          TOOLTIP: 'TREASURY.INCOME.HEADER.CONSECUTIVO.TOOLTIP',
          PLACEHOLDER: 'TREASURY.INCOME.HEADER.CONSECUTIVO.PLACEHOLDER',
        },

        TERCERO: {
          LABEL: 'TREASURY.INCOME.HEADER.TERCERO.LABEL',
          TOOLTIP: 'TREASURY.INCOME.HEADER.TERCERO.TOOLTIP',
          PLACEHOLDER: 'TREASURY.INCOME.HEADER.TERCERO.PLACEHOLDER',
          REQUIRED: 'TREASURY.INCOME.HEADER.TERCERO.REQUIRED',
          SEARCH_TOOLTIP: 'TREASURY.INCOME.HEADER.TERCERO.SEARCH_TOOLTIP',
          NOT_SELECTED: 'TREASURY.INCOME.HEADER.TERCERO.NOT_SELECTED',
        },

        NOMBRE_TERCERO: {
          LABEL: 'TREASURY.INCOME.HEADER.NOMBRE_TERCERO.LABEL',
          TOOLTIP: 'TREASURY.INCOME.HEADER.NOMBRE_TERCERO.TOOLTIP',
          PLACEHOLDER: 'TREASURY.INCOME.HEADER.NOMBRE_TERCERO.PLACEHOLDER',
        },

        FECHA_REGISTRO: {
          LABEL: 'TREASURY.INCOME.HEADER.FECHA_REGISTRO.LABEL',
          TOOLTIP: 'TREASURY.INCOME.HEADER.FECHA_REGISTRO.TOOLTIP',
          PLACEHOLDER: 'TREASURY.INCOME.HEADER.FECHA_REGISTRO.PLACEHOLDER',
          REQUIRED: 'TREASURY.INCOME.HEADER.FECHA_REGISTRO.REQUIRED',
          AUTOMATIC: 'TREASURY.INCOME.HEADER.FECHA_REGISTRO.AUTOMATIC',
        },

        FECHA_INGRESO: {
          LABEL: 'TREASURY.INCOME.HEADER.FECHA_INGRESO.LABEL',
          TOOLTIP: 'TREASURY.INCOME.HEADER.FECHA_INGRESO.TOOLTIP',
          PLACEHOLDER: 'TREASURY.INCOME.HEADER.FECHA_INGRESO.PLACEHOLDER',
          REQUIRED: 'TREASURY.INCOME.HEADER.FECHA_INGRESO.REQUIRED',
          ERROR_FUTURA: 'TREASURY.INCOME.HEADER.FECHA_INGRESO.ERROR_FUTURA',
          ERROR_MENOR_MES: 'TREASURY.INCOME.HEADER.FECHA_INGRESO.ERROR_MENOR_MES',
        },

        VALOR_TOTAL: {
          LABEL: 'TREASURY.INCOME.HEADER.VALOR_TOTAL.LABEL',
          TOOLTIP: 'TREASURY.INCOME.HEADER.VALOR_TOTAL.TOOLTIP',
          PLACEHOLDER: 'TREASURY.INCOME.HEADER.VALOR_TOTAL.PLACEHOLDER',
          REQUIRED: 'TREASURY.INCOME.HEADER.VALOR_TOTAL.REQUIRED',
          MIN: 'TREASURY.INCOME.HEADER.VALOR_TOTAL.MIN',
        },

        CONCEPTO: {
          LABEL: 'TREASURY.INCOME.HEADER.CONCEPTO.LABEL',
          TOOLTIP: 'TREASURY.INCOME.HEADER.CONCEPTO.TOOLTIP',
          PLACEHOLDER: 'TREASURY.INCOME.HEADER.CONCEPTO.PLACEHOLDER',
          REQUIRED: 'TREASURY.INCOME.HEADER.CONCEPTO.REQUIRED',
          SEARCH_TOOLTIP: 'TREASURY.INCOME.HEADER.CONCEPTO.SEARCH_TOOLTIP',
        },

        TIPO_ASIENTO: {
          LABEL: 'TREASURY.INCOME.HEADER.TIPO_ASIENTO.LABEL',
          TOOLTIP: 'TREASURY.INCOME.HEADER.TIPO_ASIENTO.TOOLTIP',
          PLACEHOLDER: 'TREASURY.INCOME.HEADER.TIPO_ASIENTO.PLACEHOLDER',
          REQUIRED: 'TREASURY.INCOME.HEADER.TIPO_ASIENTO.REQUIRED',
          SEARCH_TOOLTIP: 'TREASURY.INCOME.HEADER.TIPO_ASIENTO.SEARCH_TOOLTIP',
        },

        TIPO_COMPROBANTE: {
          LABEL: 'TREASURY.INCOME.HEADER.TIPO_COMPROBANTE.LABEL',
          TOOLTIP: 'TREASURY.INCOME.HEADER.TIPO_COMPROBANTE.TOOLTIP',
          PLACEHOLDER: 'TREASURY.INCOME.HEADER.TIPO_COMPROBANTE.PLACEHOLDER',
          REQUIRED: 'TREASURY.INCOME.HEADER.TIPO_COMPROBANTE.REQUIRED',
          OPTIONS: {
            FACTURA: 'TREASURY.INCOME.HEADER.TIPO_COMPROBANTE.OPTIONS.FACTURA',
            CONCEPTO_DIRECTO: 'TREASURY.INCOME.HEADER.TIPO_COMPROBANTE.OPTIONS.CONCEPTO_DIRECTO',
          },
        },

        DESCRIPCION: {
          LABEL: 'TREASURY.INCOME.HEADER.DESCRIPCION.LABEL',
          TOOLTIP: 'TREASURY.INCOME.HEADER.DESCRIPCION.TOOLTIP',
          PLACEHOLDER: 'TREASURY.INCOME.HEADER.DESCRIPCION.PLACEHOLDER',
          REQUIRED: 'TREASURY.INCOME.HEADER.DESCRIPCION.REQUIRED',
          MAX_LENGTH: 'TREASURY.INCOME.HEADER.DESCRIPCION.MAX_LENGTH',
          MIN_LENGTH: 'TREASURY.INCOME.HEADER.DESCRIPCION.MIN_LENGTH',
        },

        ESTADO: {
          LABEL: 'TREASURY.INCOME.HEADER.ESTADO.LABEL',
          TOOLTIP: 'TREASURY.INCOME.HEADER.ESTADO.TOOLTIP',
          OPTIONS: {
            APROBADO: 'TREASURY.INCOME.HEADER.ESTADO.OPTIONS.APROBADO',
            PENDIENTE: 'TREASURY.INCOME.HEADER.ESTADO.OPTIONS.PENDIENTE',
            RECHAZADO: 'TREASURY.INCOME.HEADER.ESTADO.OPTIONS.RECHAZADO',
          },
        },

        BUTTONS: {
          AGREGAR_FACTURA: 'TREASURY.INCOME.HEADER.BUTTONS.AGREGAR_FACTURA',
          AGREGAR_CONCEPTO_DIRECTO: 'TREASURY.INCOME.HEADER.BUTTONS.AGREGAR_CONCEPTO_DIRECTO',
          NO_FACTURAS: 'TREASURY.INCOME.HEADER.BUTTONS.NO_FACTURAS',
        },
      },

      // ----- Detalle del Registro (FN-ALC2-02) -----
      REGISTER_DETAIL: {
        TITLE: 'TREASURY.INCOME.REGISTER_DETAIL.TITLE',

        TABLE: {
          COLUMNS: {
            NUMERO_FACTURA: 'TREASURY.INCOME.REGISTER_DETAIL.TABLE.COLUMNS.NUMERO_FACTURA',
            CODIGO: 'TREASURY.INCOME.REGISTER_DETAIL.TABLE.COLUMNS.CODIGO',
            NOMBRE_CONCEPTO: 'TREASURY.INCOME.REGISTER_DETAIL.TABLE.COLUMNS.NOMBRE_CONCEPTO',
            CODIGO_ARTICULO: 'TREASURY.INCOME.REGISTER_DETAIL.TABLE.COLUMNS.CODIGO_ARTICULO',
            DESCRIPCION_ARTICULO:
              'TREASURY.INCOME.REGISTER_DETAIL.TABLE.COLUMNS.DESCRIPCION_ARTICULO',
            CANTIDAD: 'TREASURY.INCOME.REGISTER_DETAIL.TABLE.COLUMNS.CANTIDAD',
            VALOR_UNITARIO: 'TREASURY.INCOME.REGISTER_DETAIL.TABLE.COLUMNS.VALOR_UNITARIO',
            SUBTOTAL_ARTICULO: 'TREASURY.INCOME.REGISTER_DETAIL.TABLE.COLUMNS.SUBTOTAL_ARTICULO',
            VALOR_TOTAL_FACTURA:
              'TREASURY.INCOME.REGISTER_DETAIL.TABLE.COLUMNS.VALOR_TOTAL_FACTURA',
            SALDO_ARTICULO: 'TREASURY.INCOME.REGISTER_DETAIL.TABLE.COLUMNS.SALDO_ARTICULO',
            VALOR_RECAUDO: 'TREASURY.INCOME.REGISTER_DETAIL.TABLE.COLUMNS.VALOR_RECAUDO',
            CENTRO_COSTO_CODIGO:
              'TREASURY.INCOME.REGISTER_DETAIL.TABLE.COLUMNS.CENTRO_COSTO_CODIGO',
            CENTRO_COSTO_NOMBRE:
              'TREASURY.INCOME.REGISTER_DETAIL.TABLE.COLUMNS.CENTRO_COSTO_NOMBRE',
            ACCIONES: 'COMMON.ACTIONS',
          },

          VALIDATIONS: {
            CODIGO_REQUIRED: 'TREASURY.INCOME.REGISTER_DETAIL.TABLE.VALIDATIONS.CODIGO_REQUIRED',
            DESCRIPCION_MAX_LENGTH:
              'TREASURY.INCOME.REGISTER_DETAIL.TABLE.VALIDATIONS.DESCRIPCION_MAX_LENGTH',
            VALOR_RECAUDO_REQUIRED:
              'TREASURY.INCOME.REGISTER_DETAIL.TABLE.VALIDATIONS.VALOR_RECAUDO_REQUIRED',
            VALOR_RECAUDO_MIN:
              'TREASURY.INCOME.REGISTER_DETAIL.TABLE.VALIDATIONS.VALOR_RECAUDO_MIN',
            VALOR_RECAUDO_EXCEEDS:
              'TREASURY.INCOME.REGISTER_DETAIL.TABLE.VALIDATIONS.VALOR_RECAUDO_EXCEEDS',
            CENTRO_COSTO_REQUIRED:
              'TREASURY.INCOME.REGISTER_DETAIL.TABLE.VALIDATIONS.CENTRO_COSTO_REQUIRED',
            CENTRO_COSTO_MAX_LENGTH:
              'TREASURY.INCOME.REGISTER_DETAIL.TABLE.VALIDATIONS.CENTRO_COSTO_MAX_LENGTH',
          },

          ACTIONS: {
            ADD_LINE: 'TREASURY.INCOME.REGISTER_DETAIL.TABLE.ACTIONS.ADD_LINE',
            SEARCH_CENTRO_COSTO:
              'TREASURY.INCOME.REGISTER_DETAIL.TABLE.ACTIONS.SEARCH_CENTRO_COSTO',
          },

          SUMMARIES: {
            TOTALS: 'TREASURY.INCOME.REGISTER_DETAIL.TABLE.SUMMARIES.TOTALS',
          },

          TYPES: {
            FACTURA: 'TREASURY.INCOME.REGISTER_DETAIL.TABLE.TYPES.FACTURA',
            CONCEPTO_DIRECTO: 'TREASURY.INCOME.REGISTER_DETAIL.TABLE.TYPES.CONCEPTO_DIRECTO',
          },

          EMPTY: {
            MESSAGE: 'TREASURY.INCOME.REGISTER_DETAIL.TABLE.EMPTY.MESSAGE',
            DESCRIPTION: 'TREASURY.INCOME.REGISTER_DETAIL.TABLE.EMPTY.DESCRIPTION',
          },
        },

        BUTTONS: {
          ADD_FACTURA: 'TREASURY.INCOME.REGISTER_DETAIL.BUTTONS.ADD_FACTURA',
          ADD_CONCEPTO_DIRECTO: 'TREASURY.INCOME.REGISTER_DETAIL.BUTTONS.ADD_CONCEPTO_DIRECTO',
        },
      },

      // ----- Cuenta de Bancos (FN-ALC2-03) -----
      BANK_DETAIL: {
        TITLE: 'TREASURY.INCOME.BANK_DETAIL.TITLE',

        TABLE: {
          COLUMNS: {
            CODIGO_BANCO: 'TREASURY.INCOME.BANK_DETAIL.TABLE.COLUMNS.CODIGO_BANCO',
            NUMERO_CUENTA: 'TREASURY.INCOME.BANK_DETAIL.TABLE.COLUMNS.NUMERO_CUENTA',
            NOMBRE_CUENTA: 'TREASURY.INCOME.BANK_DETAIL.TABLE.COLUMNS.NOMBRE_CUENTA',
            MEDIO_PAGO: 'TREASURY.INCOME.BANK_DETAIL.TABLE.COLUMNS.MEDIO_PAGO',
            VALOR_RECAUDO: 'TREASURY.INCOME.BANK_DETAIL.TABLE.COLUMNS.VALOR_RECAUDO',
            NUMERO_DOCUMENTO: 'TREASURY.INCOME.BANK_DETAIL.TABLE.COLUMNS.NUMERO_DOCUMENTO',
            ACCIONES: 'COMMON.ACTIONS',
          },

          VALIDATIONS: {
            CODIGO_BANCO_REQUIRED:
              'TREASURY.INCOME.BANK_DETAIL.TABLE.VALIDATIONS.CODIGO_BANCO_REQUIRED',
            CODIGO_BANCO_MAX_LENGTH:
              'TREASURY.INCOME.BANK_DETAIL.TABLE.VALIDATIONS.CODIGO_BANCO_MAX_LENGTH',
            MEDIO_PAGO_REQUIRED:
              'TREASURY.INCOME.BANK_DETAIL.TABLE.VALIDATIONS.MEDIO_PAGO_REQUIRED',
            VALOR_RECAUDO_REQUIRED:
              'TREASURY.INCOME.BANK_DETAIL.TABLE.VALIDATIONS.VALOR_RECAUDO_REQUIRED',
            VALOR_RECAUDO_MIN: 'TREASURY.INCOME.BANK_DETAIL.TABLE.VALIDATIONS.VALOR_RECAUDO_MIN',
            VALOR_RECAUDO_EXCEEDS:
              'TREASURY.INCOME.BANK_DETAIL.TABLE.VALIDATIONS.VALOR_RECAUDO_EXCEEDS',
            NUMERO_DOCUMENTO_MAX_LENGTH:
              'TREASURY.INCOME.BANK_DETAIL.TABLE.VALIDATIONS.NUMERO_DOCUMENTO_MAX_LENGTH',
          },

          ACTIONS: {
            ADD_BANCO: 'TREASURY.INCOME.BANK_DETAIL.TABLE.ACTIONS.ADD_BANCO',
            SEARCH_BANCO: 'TREASURY.INCOME.BANK_DETAIL.TABLE.ACTIONS.SEARCH_BANCO',
          },

          SUMMARIES: {
            TOTALS: 'TREASURY.INCOME.BANK_DETAIL.TABLE.SUMMARIES.TOTALS',
          },

          MEDIO_PAGO_OPTIONS: {
            TRANSFERENCIA: 'TREASURY.INCOME.BANK_DETAIL.TABLE.MEDIO_PAGO_OPTIONS.TRANSFERENCIA',
            TARJETA_DEBITO: 'TREASURY.INCOME.BANK_DETAIL.TABLE.MEDIO_PAGO_OPTIONS.TARJETA_DEBITO',
            TARJETA_CREDITO: 'TREASURY.INCOME.BANK_DETAIL.TABLE.MEDIO_PAGO_OPTIONS.TARJETA_CREDITO',
            CONSIGNACION: 'TREASURY.INCOME.BANK_DETAIL.TABLE.MEDIO_PAGO_OPTIONS.CONSIGNACION',
            BRE_B: 'TREASURY.INCOME.BANK_DETAIL.TABLE.MEDIO_PAGO_OPTIONS.BRE_B',
          },

          EMPTY: {
            MESSAGE: 'TREASURY.INCOME.BANK_DETAIL.TABLE.EMPTY.MESSAGE',
            DESCRIPTION: 'TREASURY.INCOME.BANK_DETAIL.TABLE.EMPTY.DESCRIPTION',
          },
        },
      },

      // ----- Cuenta de Deducción (FN-ALC2-04) -----
      DEDUCTIONS: {
        TITLE: 'TREASURY.INCOME.DEDUCTIONS.TITLE',

        TABLE: {
          COLUMNS: {
            CUENTA: 'TREASURY.INCOME.DEDUCTIONS.TABLE.COLUMNS.CUENTA',
            NOMBRE_CUENTA: 'TREASURY.INCOME.DEDUCTIONS.TABLE.COLUMNS.NOMBRE_CUENTA',
            VALOR: 'TREASURY.INCOME.DEDUCTIONS.TABLE.COLUMNS.VALOR',
            ACCIONES: 'COMMON.ACTIONS',
          },

          VALIDATIONS: {
            CUENTA_REQUIRED: 'TREASURY.INCOME.DEDUCTIONS.TABLE.VALIDATIONS.CUENTA_REQUIRED',
            CUENTA_MAX_LENGTH: 'TREASURY.INCOME.DEDUCTIONS.TABLE.VALIDATIONS.CUENTA_MAX_LENGTH',
            VALOR_REQUIRED: 'TREASURY.INCOME.DEDUCTIONS.TABLE.VALIDATIONS.VALOR_REQUIRED',
            VALOR_MIN: 'TREASURY.INCOME.DEDUCTIONS.TABLE.VALIDATIONS.VALOR_MIN',
            VALOR_EXCEEDS: 'TREASURY.INCOME.DEDUCTIONS.TABLE.VALIDATIONS.VALOR_EXCEEDS',
          },

          ACTIONS: {
            ADD_DEDUCCION: 'TREASURY.INCOME.DEDUCTIONS.TABLE.ACTIONS.ADD_DEDUCCION',
            SEARCH_DEDUCCION: 'TREASURY.INCOME.DEDUCTIONS.TABLE.ACTIONS.SEARCH_DEDUCCION',
          },

          SUMMARIES: {
            TOTALS: 'TREASURY.INCOME.DEDUCTIONS.TABLE.SUMMARIES.TOTALS',
          },

          EMPTY: {
            MESSAGE: 'TREASURY.INCOME.DEDUCTIONS.TABLE.EMPTY.MESSAGE',
            DESCRIPTION: 'TREASURY.INCOME.DEDUCTIONS.TABLE.EMPTY.DESCRIPTION',
          },
        },
      },
    },

    // ==================== ACCIONES DEL HEADER ====================
    ACTIONS: {
      CREATE: 'ACTIONS.CREATE',
      REFRESH: 'ACTIONS.REFRESH',
      CANCEL: 'ACTIONS.CANCEL',
      SAVE: 'ACTIONS.SAVE',
      SAVING: 'ACTIONS.SAVING',
      VIEW: 'ACTIONS.VIEW',
      EDIT: 'ACTIONS.EDIT',
      DELETE: 'ACTIONS.DELETE',
    },

    // ==================== ALERTAS ====================
    ALERTS: {
      LOAD_ERROR: {
        TITLE: 'TREASURY.INCOME.ALERTS.LOAD_ERROR.TITLE',
        MESSAGE: 'TREASURY.INCOME.ALERTS.LOAD_ERROR.MESSAGE',
      },
      SAVE_SUCCESS: {
        TITLE: 'TREASURY.INCOME.ALERTS.SAVE_SUCCESS.TITLE',
        MESSAGE: 'TREASURY.INCOME.ALERTS.SAVE_SUCCESS.MESSAGE',
      },
      SAVE_ERROR: {
        TITLE: 'TREASURY.INCOME.ALERTS.SAVE_ERROR.TITLE',
        MESSAGE: 'TREASURY.INCOME.ALERTS.SAVE_ERROR.MESSAGE',
      },
      UPDATE_SUCCESS: {
        TITLE: 'TREASURY.INCOME.ALERTS.UPDATE_SUCCESS.TITLE',
        MESSAGE: 'TREASURY.INCOME.ALERTS.UPDATE_SUCCESS.MESSAGE',
      },
      UPDATE_ERROR: {
        TITLE: 'TREASURY.INCOME.ALERTS.UPDATE_ERROR.TITLE',
        MESSAGE: 'TREASURY.INCOME.ALERTS.UPDATE_ERROR.MESSAGE',
      },
      DELETE_SUCCESS: {
        TITLE: 'TREASURY.INCOME.ALERTS.DELETE_SUCCESS.TITLE',
        MESSAGE: 'TREASURY.INCOME.ALERTS.DELETE_SUCCESS.MESSAGE',
      },
      DELETE_ERROR: {
        TITLE: 'TREASURY.INCOME.ALERTS.DELETE_ERROR.TITLE',
        MESSAGE: 'TREASURY.INCOME.ALERTS.DELETE_ERROR.MESSAGE',
      },
      PERMISSION_ERROR: {
        TITLE: 'TREASURY.INCOME.ALERTS.PERMISSION_ERROR.TITLE',
        CREATE_DENIED: 'TREASURY.INCOME.ALERTS.PERMISSION_ERROR.CREATE_DENIED',
        EDIT_DENIED: 'TREASURY.INCOME.ALERTS.PERMISSION_ERROR.EDIT_DENIED',
        DELETE_DENIED: 'TREASURY.INCOME.ALERTS.PERMISSION_ERROR.DELETE_DENIED',
        VIEW_DENIED: 'TREASURY.INCOME.ALERTS.PERMISSION_ERROR.VIEW_DENIED',
      },
      SELECTION_ERROR: {
        TITLE: 'TREASURY.INCOME.ALERTS.SELECTION_ERROR.TITLE',
        TERCERO_ERROR: 'TREASURY.INCOME.ALERTS.SELECTION_ERROR.TERCERO_ERROR',
        CONCEPTO_ERROR: 'TREASURY.INCOME.ALERTS.SELECTION_ERROR.CONCEPTO_ERROR',
        CONCEPTO_FACTURACION_ERROR:
          'TREASURY.INCOME.ALERTS.SELECTION_ERROR.CONCEPTO_FACTURACION_ERROR',
        TIPO_ASIENTO_ERROR: 'TREASURY.INCOME.ALERTS.SELECTION_ERROR.TIPO_ASIENTO_ERROR',
        FACTURAS_ERROR: 'TREASURY.INCOME.ALERTS.SELECTION_ERROR.FACTURAS_ERROR',
        FACTURAS_503: 'TREASURY.INCOME.ALERTS.SELECTION_ERROR.FACTURAS_503',
      },
    },

    // ==================== CONFIRMACIONES ====================
    CONFIRM_DIALOGS: {
      CANCEL: {
        TITLE: 'TREASURY.INCOME.CONFIRM_DIALOGS.CANCEL.TITLE',
        MESSAGE: 'TREASURY.INCOME.CONFIRM_DIALOGS.CANCEL.MESSAGE',
        CONFIRM_LABEL: 'TREASURY.INCOME.CONFIRM_DIALOGS.CANCEL.CONFIRM_LABEL',
        CANCEL_LABEL: 'TREASURY.INCOME.CONFIRM_DIALOGS.CANCEL.CANCEL_LABEL',
      },
      DELETE: {
        TITLE: 'TREASURY.INCOME.CONFIRM_DIALOGS.DELETE.TITLE',
        MESSAGE: 'TREASURY.INCOME.CONFIRM_DIALOGS.DELETE.MESSAGE',
        CONFIRM_LABEL: 'TREASURY.INCOME.CONFIRM_DIALOGS.DELETE.CONFIRM_LABEL',
        CANCEL_LABEL: 'ACTIONS.CANCEL',
      },
      REGISTER_DETAIL_DELETE: {
        FACTURA: {
          TITLE: 'TREASURY.INCOME.CONFIRM_DIALOGS.REGISTER_DETAIL_DELETE.FACTURA.TITLE',
          MESSAGE: 'TREASURY.INCOME.CONFIRM_DIALOGS.REGISTER_DETAIL_DELETE.FACTURA.MESSAGE',
        },
        CONCEPTO: {
          TITLE: 'TREASURY.INCOME.CONFIRM_DIALOGS.REGISTER_DETAIL_DELETE.CONCEPTO.TITLE',
          MESSAGE: 'TREASURY.INCOME.CONFIRM_DIALOGS.REGISTER_DETAIL_DELETE.CONCEPTO.MESSAGE',
        },
        CONFIRM_LABEL: 'TREASURY.INCOME.CONFIRM_DIALOGS.REGISTER_DETAIL_DELETE.CONFIRM_LABEL',
        CANCEL_LABEL: 'ACTIONS.CANCEL',
      },
      BANK_DETAIL_DELETE: {
        TITLE: 'TREASURY.INCOME.CONFIRM_DIALOGS.BANK_DETAIL_DELETE.TITLE',
        MESSAGE: 'TREASURY.INCOME.CONFIRM_DIALOGS.BANK_DETAIL_DELETE.MESSAGE',
        SINGLE_LINE_MESSAGE:
          'TREASURY.INCOME.CONFIRM_DIALOGS.BANK_DETAIL_DELETE.SINGLE_LINE_MESSAGE',
        CONFIRM_LABEL: 'TREASURY.INCOME.CONFIRM_DIALOGS.BANK_DETAIL_DELETE.CONFIRM_LABEL',
        CANCEL_LABEL: 'ACTIONS.CANCEL',
      },
      DEDUCTIONS_DELETE: {
        TITLE: 'TREASURY.INCOME.CONFIRM_DIALOGS.DEDUCTIONS_DELETE.TITLE',
        MESSAGE: 'TREASURY.INCOME.CONFIRM_DIALOGS.DEDUCTIONS_DELETE.MESSAGE',
        SINGLE_LINE_MESSAGE:
          'TREASURY.INCOME.CONFIRM_DIALOGS.DEDUCTIONS_DELETE.SINGLE_LINE_MESSAGE',
        CONFIRM_LABEL: 'TREASURY.INCOME.CONFIRM_DIALOGS.DEDUCTIONS_DELETE.CONFIRM_LABEL',
        CANCEL_LABEL: 'ACTIONS.CANCEL',
      },
      NO_SALDO: {
        TITLE: 'TREASURY.INCOME.CONFIRM_DIALOGS.NO_SALDO.TITLE',
        BANK_MESSAGE: 'TREASURY.INCOME.CONFIRM_DIALOGS.NO_SALDO.BANK_MESSAGE',
        DEDUCTION_MESSAGE: 'TREASURY.INCOME.CONFIRM_DIALOGS.NO_SALDO.DEDUCTION_MESSAGE',
        CONFIRM_LABEL: 'ACTIONS.ACCEPT',
      },
    },

    // ==================== MODALES ====================
    MODALS: {
      TERCERO: {
        TITLE: 'TREASURY.INCOME.MODALS.TERCERO.TITLE',
      },
      CENTRO_COSTO: {
        TITLE: 'TREASURY.INCOME.MODALS.CENTRO_COSTO.TITLE',
      },
      BANCO: {
        TITLE: 'TREASURY.INCOME.MODALS.BANCO.TITLE',
      },
      CUENTA_CONTABLE: {
        TITLE: 'TREASURY.INCOME.MODALS.CUENTA_CONTABLE.TITLE',
      },
    },

    // ==================== ERRORES ====================
    ERROR_MESSAGES: {
      REQUIRED_FIELD: 'TREASURY.INCOME.ERROR_MESSAGES.REQUIRED_FIELD',
      INVALID_FORM: 'TREASURY.INCOME.ERROR_MESSAGES.INVALID_FORM',
      TERCERO_INVALIDO: 'TREASURY.INCOME.ERROR_MESSAGES.TERCERO_INVALIDO',
      FECHA_FUTURA: 'TREASURY.INCOME.ERROR_MESSAGES.FECHA_FUTURA',
      FECHA_MENOR_MES_CERRADO: 'TREASURY.INCOME.ERROR_MESSAGES.FECHA_MENOR_MES_CERRADO',
      VALOR_TOTAL_INVALID: 'TREASURY.INCOME.ERROR_MESSAGES.VALOR_TOTAL_INVALID',
      CONCEPTO_NOT_FOUND: 'TREASURY.INCOME.ERROR_MESSAGES.CONCEPTO_NOT_FOUND',
      FACTURA_NO_SALDO: 'TREASURY.INCOME.ERROR_MESSAGES.FACTURA_NO_SALDO',
      FACTURA_YA_AGREGADA: 'TREASURY.INCOME.ERROR_MESSAGES.FACTURA_YA_AGREGADA',
      FACTURA_INVALIDA: 'TREASURY.INCOME.ERROR_MESSAGES.FACTURA_INVALIDA',
      FACTURA_NO_ENCONTRADA: 'TREASURY.INCOME.ERROR_MESSAGES.FACTURA_NO_ENCONTRADA',
      CENTRO_COSTO_OBLIGATORIO: 'TREASURY.INCOME.ERROR_MESSAGES.CENTRO_COSTO_OBLIGATORIO',
      NO_FACTURAS_DISPONIBLES: 'TREASURY.INCOME.ERROR_MESSAGES.NO_FACTURAS_DISPONIBLES',
      DETALLE_CARGA_ERROR: 'TREASURY.INCOME.ERROR_MESSAGES.DETALLE_CARGA_ERROR',
      SALDO_POR_RECAUDAR: 'TREASURY.INCOME.ERROR_MESSAGES.SALDO_POR_RECAUDAR',
      TIPO_ASIENTO_INVALIDO: 'TREASURY.INCOME.ERROR_MESSAGES.TIPO_ASIENTO_INVALIDO',
    },

    // ==================== INFORMACIÓN ====================
    INFO_MESSAGES: {
      TERCERO_SELECTED: 'TREASURY.INCOME.INFO_MESSAGES.TERCERO_SELECTED',
      BANCO_SELECTED: 'TREASURY.INCOME.INFO_MESSAGES.BANCO_SELECTED',
      CUENTA_SELECTED: 'TREASURY.INCOME.INFO_MESSAGES.CUENTA_SELECTED',
      CENTRO_COSTO_SELECTED: 'TREASURY.INCOME.INFO_MESSAGES.CENTRO_COSTO_SELECTED',
      NO_DEDUCTIONS: 'TREASURY.INCOME.INFO_MESSAGES.NO_DEDUCTIONS',
    },

    // ==================== TABS ====================
    TABS: {
      DETAIL: 'TREASURY.INCOME.TABS.DETAIL',
      BANK_DETAIL: 'TREASURY.INCOME.TABS.BANK_DETAIL',
      DEDUCTIONS: 'TREASURY.INCOME.TABS.DEDUCTIONS',
    },
  },

  THIRD_PARTY: {
    EMPTY: {
      DEFAULT: 'TREASURY.BANK_PAYMENTS.EMPTY.DEFAULT', // No hay comprobantes programados para pago el día de hoy
      SEARCH: 'TREASURY.BANK_PAYMENTS.EMPTY.SEARCH', // No se encontraron comprobantes que coincidan con la búsqueda
      DESCRIPTION: 'TREASURY.BANK_PAYMENTS.EMPTY.DESCRIPTION', // Intente con otro criterio o verifique la programación de egresos
      DETAIL: 'TREASURY.BANK_PAYMENTS.EMPTY.DETAIL', // Seleccione un comprobante con Pagar para ver el detalle
      DETAIL_DESCRIPTION: 'TREASURY.BANK_PAYMENTS.EMPTY.DETAIL_DESCRIPTION', // La información de O.P. / anticipo se muestra al seleccionar filas
    },
    COUNTER: {
      SINGULAR: 'TREASURY.BANK_PAYMENTS.COUNTER.SINGULAR', // comprobante
      PLURAL: 'TREASURY.BANK_PAYMENTS.COUNTER.PLURAL', // comprobantes
    },
    ACTION: {
      PAY: 'TREASURY.BANK_PAYMENTS.ACTION.PAY', // Pagar
      REJECT: 'TREASURY.BANK_PAYMENTS.ACTION.REJECT', // Rechazar
      SELECT_ACCOUNT: 'TREASURY.BANK_PAYMENTS.ACTION.SELECT_ACCOUNT', // Seleccionar cuenta
      PAY_ALL: 'TREASURY.BANK_PAYMENTS.ACTION.PAY_ALL', // Pagar todos (legacy)
      REJECT_ALL: 'TREASURY.BANK_PAYMENTS.ACTION.REJECT_ALL', // Rechazar todos (legacy)
      REFRESH: 'ACTIONS.REFRESH', // Refrescar (common_keys) — header como Aprobar Causación
      SAVE: 'ACTIONS.SAVE', // Guardar (common_keys)
      ACCEPT: 'ACTIONS.ACCEPT', // Aceptar (common_keys) — modal rechazo
      BACK: 'ACTIONS.BACK', // Volver (common_keys) — detalle consultar
      CANCEL: 'ACTIONS.CANCEL', // Cancelar (common_keys)
      VIEW: 'ACTIONS.VIEW', // Consultar (common_keys)
      CLOSE: 'TREASURY.PARAMETERS.ACCOUNT_SEARCH.CLOSE', // Cerrar / Close
    },
    MODAL: {
      SELECT_ACCOUNT: 'TREASURY.BANK_PAYMENTS.MODAL.SELECT_ACCOUNT', // Seleccionar cuenta bancaria
      REJECT_TITLE: 'TREASURY.BANK_PAYMENTS.MODAL.REJECT_TITLE', // Rechazar Documento(s) — alineado a Aprobar Causación
      REJECT_LABEL: 'TREASURY.BANK_PAYMENTS.MODAL.REJECT_LABEL', // Motivo de rechazo
      REJECT_PLACEHOLDER: 'TREASURY.BANK_PAYMENTS.MODAL.REJECT_PLACEHOLDER', // Ingrese el motivo del rechazo
      COL_CODE: 'TREASURY.BANK_PAYMENTS.MODAL.COL_CODE', // Código
      COL_NAME: 'TREASURY.BANK_PAYMENTS.MODAL.COL_NAME', // Nombre
      COL_BALANCE: 'TREASURY.BANK_PAYMENTS.LABEL.BALANCE', // Saldo (reusa LABEL.BALANCE)
      SEARCH_ACCOUNT: 'TREASURY.BANK_PAYMENTS.MODAL.SEARCH_ACCOUNT', // Buscar por código o nombre...
      CONFIRM_PAY_TITLE: 'TREASURY.BANK_PAYMENTS.MODAL.CONFIRM_PAY_TITLE', // Confirmar pago
    },
    LABEL: {
      METHOD: 'TREASURY.BANK_PAYMENTS.LABEL.METHOD', // Método de pago
      ACCOUNT: 'TREASURY.BANK_PAYMENTS.LABEL.ACCOUNT', // Cuenta bancaria
      ACCOUNT_CODE: 'TREASURY.PARAMETERS.FIELDS.ACCOUNT.CODE.LABEL', // Código Cuenta (reusa parámetros)
      ACCOUNT_NAME: 'TREASURY.PARAMETERS.FIELDS.ACCOUNT.NAME.LABEL', // Nombre Cuenta (reusa parámetros)
      BALANCE: 'TREASURY.BANK_PAYMENTS.LABEL.BALANCE', // Saldo
      ACCOUNT_BALANCE: 'TREASURY.BANK_PAYMENTS.LABEL.ACCOUNT_BALANCE', // Saldo de la Cuenta
      PAY_VALUE: 'TREASURY.BANK_PAYMENTS.LABEL.PAY_VALUE', // Valor a pagar
      FINAL_BALANCE: 'TREASURY.BANK_PAYMENTS.LABEL.FINAL_BALANCE', // Saldo final
      CHECK_NUMBER: 'TREASURY.BANK_PAYMENTS.LABEL.CHECK_NUMBER', // Número de cheque
      TIPO_CE: 'TREASURY.BANK_PAYMENTS.LABEL.TIPO_CE', // Tipo de Comprobante de Egreso
      SEARCH: 'LABELS.SEARCH', // Búsqueda (common_keys)
      PAYMENT_DATE: 'TREASURY.BANK_PAYMENTS.COLUMN.PAYMENT_DATE', // Fecha de pago (reusa COLUMN)
      TOTAL: 'TREASURY.BANK_PAYMENTS.COLUMN.TOTAL', // Valor Total (reusa COLUMN)
    },
    OPTION: {
      GIRAR: 'TREASURY.BANK_PAYMENTS.OPTION.GIRAR', // Girar
      TRANSFERIR: 'TREASURY.BANK_PAYMENTS.OPTION.TRANSFERIR', // Transferir
    },
    MESSAGE: {
      PAY_SUCCESS: 'TREASURY.BANK_PAYMENTS.MESSAGE.PAY_SUCCESS', // El pago/giro se ha registrado correctamente
      REJECT_SUCCESS: 'TREASURY.BANK_PAYMENTS.MESSAGE.REJECT_SUCCESS', // Comprobante(s) rechazado(s) correctamente
      SELECTION_REQUIRED: 'TREASURY.BANK_PAYMENTS.MESSAGE.SELECTION_REQUIRED', // Elige al menos un documento para el pago o rechazo
      ACCOUNT_REQUIRED: 'TREASURY.BANK_PAYMENTS.MESSAGE.ACCOUNT_REQUIRED', // Debe seleccionar al menos una cuenta
      METHOD_REQUIRED: 'TREASURY.BANK_PAYMENTS.MESSAGE.METHOD_REQUIRED', // Debe indicar Girar (cheque) o Transferir
      CHECK_REQUIRED: 'TREASURY.BANK_PAYMENTS.MESSAGE.CHECK_REQUIRED', // Al girar debe indicar el número de cheque
      MOTIVO_MIN: 'TREASURY.BANK_PAYMENTS.MESSAGE.MOTIVO_MIN', // El motivo de rechazo debe tener al menos {min} caracteres
      MOTIVO_MAX: 'TREASURY.BANK_PAYMENTS.MESSAGE.MOTIVO_MAX', // El motivo de rechazo no puede exceder {max} caracteres
      MOTIVO_REQUIRED: 'TREASURY.BANK_PAYMENTS.MESSAGE.MOTIVO_REQUIRED', // El motivo de rechazo es obligatorio
      CONFIRM_REJECT: 'TREASURY.BANK_PAYMENTS.MESSAGE.CONFIRM_REJECT', // Se realizará el rechazo del documento, ¿desea continuar?
      CONFIRM_PAY: 'TREASURY.BANK_PAYMENTS.MESSAGE.CONFIRM_PAY', // ¿Está seguro de procesar el pago de {count} comprobante(s)?
      LOAD_ERROR: 'TREASURY.BANK_PAYMENTS.MESSAGE.LOAD_ERROR', // No se pudo cargar el listado de comprobantes para pago
      READ_ERROR: 'TREASURY.BANK_PAYMENTS.MESSAGE.READ_ERROR', // No se pudo consultar el comprobante
      PAY_ERROR: 'TREASURY.BANK_PAYMENTS.MESSAGE.PAY_ERROR', // No se pudo procesar el pago. Intente nuevamente.
      REJECT_ERROR: 'TREASURY.BANK_PAYMENTS.MESSAGE.REJECT_ERROR', // No se pudo rechazar el/los comprobante(s).
      SEARCH_HINT_MIN: 'TREASURY.BANK_PAYMENTS.MESSAGE.SEARCH_HINT_MIN', // Debe ingresar entre {min} y {max} caracteres
      SEARCH_HINT_MAX: 'TREASURY.BANK_PAYMENTS.MESSAGE.SEARCH_HINT_MAX', // Máximo {max} caracteres
      PERMISSION_DENIED: 'TREASURY.BANK_PAYMENTS.MESSAGE.PERMISSION_DENIED', // No tiene permisos para realizar esta acción
    },
    PERMISSION: {
      DENIED_SAVE: 'TREASURY.BANK_PAYMENTS.PERMISSION.DENIED_SAVE', // No tiene permisos para guardar / pagar
      DENIED_REJECT: 'TREASURY.BANK_PAYMENTS.PERMISSION.DENIED_REJECT', // No tiene permisos para rechazar
      DENIED_VIEW: 'TREASURY.BANK_PAYMENTS.PERMISSION.DENIED_VIEW', // No tiene permisos para consultar
    },
  },

  /** HU-TES-008 — Anulación de Comprobantes de Ingreso. */
  CANCELLATION_INCOME: {
    TITLE: {
      LIST: 'TREASURY.CANCELLATION_INCOME.TITLE.LIST', // Anulación de Ingresos
      VIEW: 'TREASURY.CANCELLATION_INCOME.TITLE.VIEW', // Consultar comprobante de ingreso
    },
    SUBTITLE: {
      LIST: 'TREASURY.CANCELLATION_INCOME.SUBTITLE.LIST', // Comprobantes de ingreso aprobados de la vigencia activa
      VIEW: 'TREASURY.CANCELLATION_INCOME.SUBTITLE.VIEW', // Detalle del comprobante de ingreso
    },
    COLUMN: {
      CONSECUTIVE: 'TREASURY.CANCELLATION_INCOME.COLUMN.CONSECUTIVE', // Consecutivo
      IDENTIFICATION: 'TREASURY.BANK_PAYMENTS.COLUMN.IDENTIFICATION', // No. Identificación (reusa)
      NAME: 'TREASURY.BANK_PAYMENTS.COLUMN.NAME', // Nombre o Razón Social (reusa)
      DATE: 'TREASURY.CANCELLATION_INCOME.COLUMN.DATE', // Fecha CI
      VALUE: 'TREASURY.BANK_PAYMENTS.COLUMN.VALUE', // Valor (reusa)
      STATUS: 'TREASURY.BANK_PAYMENTS.COLUMN.STATUS', // Estado (reusa)
      MOTIVO: 'TREASURY.CANCELLATION_INCOME.COLUMN.MOTIVO', // Motivo anulación
    },
    PLACEHOLDER: {
      SEARCH: 'TREASURY.CANCELLATION_INCOME.PLACEHOLDER.SEARCH', // Buscar por consecutivo, identificación o tercero
    },
    EMPTY: {
      DEFAULT: 'TREASURY.CANCELLATION_INCOME.EMPTY.DEFAULT', // No hay comprobantes de ingreso anulables
      SEARCH: 'TREASURY.CANCELLATION_INCOME.EMPTY.SEARCH', // No se encontraron comprobantes que coincidan con la búsqueda
      DESCRIPTION: 'TREASURY.CANCELLATION_INCOME.EMPTY.DESCRIPTION', // Intente con otro criterio o verifique los CI en estado Aprobado
    },
    COUNTER: {
      SINGULAR: 'TREASURY.CANCELLATION_INCOME.COUNTER.SINGULAR', // comprobante
      PLURAL: 'TREASURY.CANCELLATION_INCOME.COUNTER.PLURAL', // comprobantes
    },
    OPTION: {
      APROBADO: 'TREASURY.INCOME.FILTERS.ESTADO.OPTIONS.APROBADO', // Aprobado (reusa Ingresos)
      ANULADO: 'TREASURY.CANCELLATION_INCOME.OPTION.ANULADO', // Anulado / Annulled
    },
    ACTION: {
      ANNUL: 'TREASURY.CANCELLATION_INCOME.ACTION.ANNUL', // Anular
      CANCEL: 'ACTIONS.BACK', // Cancelar (common_keys)
      VIEW: 'ACTIONS.VIEW', // Consultar (common_keys)
      REFRESH: 'ACTIONS.REFRESH', // Refrescar (common_keys)
    },
    MODAL: {
      ANNUL_TITLE: 'TREASURY.CANCELLATION_INCOME.MODAL.ANNUL_TITLE', // Motivo de anulación
      ANNUL_LABEL: 'TREASURY.CANCELLATION_INCOME.MODAL.ANNUL_LABEL', // Motivo
      ANNUL_PLACEHOLDER: 'TREASURY.CANCELLATION_INCOME.MODAL.ANNUL_PLACEHOLDER', // Ingrese el motivo (mínimo 5 caracteres)
      ANNUL_DESCRIPTION: 'TREASURY.CANCELLATION_INCOME.MODAL.ANNUL_DESCRIPTION', // ¿Está seguro de anular {count} comprobante(s)?
    },
    LABEL: {
      SEARCH: 'LABELS.SEARCH', // Buscar (common_keys)
      CONSECUTIVE: 'TREASURY.CANCELLATION_INCOME.COLUMN.CONSECUTIVE',
      IDENTIFICATION: 'TREASURY.BANK_PAYMENTS.COLUMN.IDENTIFICATION',
      NAME: 'TREASURY.BANK_PAYMENTS.COLUMN.NAME',
      DATE: 'TREASURY.CANCELLATION_INCOME.COLUMN.DATE',
      VALUE: 'TREASURY.BANK_PAYMENTS.COLUMN.VALUE',
      STATUS: 'TREASURY.BANK_PAYMENTS.COLUMN.STATUS',
      MOTIVO: 'TREASURY.CANCELLATION_INCOME.COLUMN.MOTIVO',
    },
    MESSAGE: {
      ANNUL_SUCCESS: 'TREASURY.CANCELLATION_INCOME.MESSAGE.ANNUL_SUCCESS', // Comprobante(s) anulado(s) correctamente
      ANNUL_PARTIAL: 'TREASURY.CANCELLATION_INCOME.MESSAGE.ANNUL_PARTIAL', // Anulación parcial: {ok} anulados; no anulados ({fail}): {consecutivos}
      SELECTION_REQUIRED: 'TREASURY.CANCELLATION_INCOME.MESSAGE.SELECTION_REQUIRED', // Seleccione al menos un comprobante para anular
      MOTIVO_MIN: 'TREASURY.CANCELLATION_INCOME.MESSAGE.MOTIVO_MIN', // El motivo debe tener al menos {min} caracteres
      MOTIVO_MAX: 'TREASURY.CANCELLATION_INCOME.MESSAGE.MOTIVO_MAX', // El motivo no puede exceder {max} caracteres
      MOTIVO_REQUIRED: 'TREASURY.CANCELLATION_INCOME.MESSAGE.MOTIVO_REQUIRED', // El motivo de anulación es obligatorio
      LOAD_ERROR: 'TREASURY.CANCELLATION_INCOME.MESSAGE.LOAD_ERROR', // No se pudo cargar el listado de comprobantes
      READ_ERROR: 'TREASURY.CANCELLATION_INCOME.MESSAGE.READ_ERROR', // No se pudo consultar el comprobante
      ANNUL_ERROR: 'TREASURY.CANCELLATION_INCOME.MESSAGE.ANNUL_ERROR', // No se pudo anular el/los comprobante(s)
      SEARCH_HINT_MIN: 'TREASURY.CANCELLATION_INCOME.MESSAGE.SEARCH_HINT_MIN', // Debe ingresar entre {min} y {max} caracteres
      SEARCH_HINT_MAX: 'TREASURY.CANCELLATION_INCOME.MESSAGE.SEARCH_HINT_MAX', // Máximo {max} caracteres
      PERMISSION_DENIED: 'TREASURY.CANCELLATION_INCOME.MESSAGE.PERMISSION_DENIED', // No tiene permisos para realizar esta acción
    },
    PERMISSION: {
      DENIED_ANNUL: 'TREASURY.CANCELLATION_INCOME.PERMISSION.DENIED_ANNUL', // No tiene permisos para anular
      DENIED_VIEW: 'TREASURY.CANCELLATION_INCOME.PERMISSION.DENIED_VIEW', // No tiene permisos para consultar
    },
  },

  /** HU-TES-010 — Banco / Pagos (giro de comprobantes de egreso). */
  BANK_PAYMENTS: {
    TITLE: {
      LIST: 'TREASURY.BANK_PAYMENTS.TITLE.LIST', // Pagos Bancarios / Banco Pagos
      VIEW: 'TREASURY.BANK_PAYMENTS.TITLE.VIEW', // Consultar comprobante para pago
    },
    SUBTITLE: {
      LIST: 'TREASURY.BANK_PAYMENTS.SUBTITLE.LIST', // Comprobantes de egreso programados para pago
      VIEW: 'TREASURY.BANK_PAYMENTS.SUBTITLE.VIEW', // Detalle del comprobante de egreso
    },
    SECTION: {
      LIST: 'TREASURY.BANK_PAYMENTS.SECTION.LIST', // Listado de Egresos para Pago
      PAYMENT: 'TREASURY.BANK_PAYMENTS.SECTION.PAYMENT', // Datos para el Pago
      VOUCHER: 'TREASURY.BANK_PAYMENTS.SECTION.VOUCHER', // Datos Comprobante de Egresos
    },
    /**
     * Tabs de consultar: reutiliza keys ya en BD.
     * GENERAL → Accounting terceros; STATUS_LOG/DEDUCTIONS/labels → Egresos (TES).
     */
    TAB: {
      GENERAL: 'TREASURY.EXPENSES.TAB.TITLE.GENERAL_INFO', // Información general
      GENERAL_SUB: 'TREASURY.EXPENSES.TAB.SUBTITLE.GENERAL_INFO',
      VOUCHER: 'TREASURY.BANK_PAYMENTS.SECTION.VOUCHER', // Datos Comprobante de Egresos
      VOUCHER_SUB: 'TREASURY.BANK_PAYMENTS.SUBTITLE.VIEW',
      PAYMENT_ORDERS: 'ACCOUNTING.CAUSACION.TAB.ORDEN_PAGO', // Orden de Pago
      PAYMENT_ORDERS_SUB: 'TREASURY.BANK_PAYMENTS.COLUMN.OP_ANTICIPO', // No. O.P. o Anticipo
      STATUS_LOG: 'TREASURY.EXPENSES.TAB.STATUS_LOG', // Bitácora de estados
      STATUS_LOG_SUB: 'TREASURY.BANK_PAYMENTS.EMPTY.DETAIL_DESCRIPTION',
      DEDUCTIONS: 'TREASURY.EXPENSES.TAB.DEDUCTIONS', // Deducciones aplicadas
      DEDUCTIONS_SUB: 'TREASURY.INCOME.INFO_MESSAGES.NO_DEDUCTIONS',
    },
    COLUMN: {
      PAY: 'TREASURY.BANK_PAYMENTS.ACTION.PAY', // Pagar (reusa ACTION.PAY)
      REJECT: 'TREASURY.BANK_PAYMENTS.ACTION.REJECT', // Rechazar (reusa ACTION.REJECT)
      TIPO_CE: 'TREASURY.BANK_PAYMENTS.COLUMN.TIPO_CE', // Tipo CE
      VOUCHER: 'TREASURY.BANK_PAYMENTS.COLUMN.VOUCHER', // Comprobante
      IDENTIFICATION: 'TREASURY.BANK_PAYMENTS.COLUMN.IDENTIFICATION', // No. Identificación
      NAME: 'TREASURY.BANK_PAYMENTS.COLUMN.NAME', // Nombre o Razón Social
      PAYMENT_DATE: 'TREASURY.BANK_PAYMENTS.COLUMN.PAYMENT_DATE', // Fecha de pago
      VOUCHER_DATE: 'TREASURY.BANK_PAYMENTS.COLUMN.VOUCHER_DATE', // Fecha Comprobante Egreso
      VALUE: 'TREASURY.BANK_PAYMENTS.COLUMN.VALUE', // Valor
      VOUCHER_VALUE: 'TREASURY.BANK_PAYMENTS.COLUMN.VOUCHER_VALUE', // Valor Comprobante de Egreso
      STATUS: 'TREASURY.BANK_PAYMENTS.COLUMN.STATUS', // Estado
      OP_ANTICIPO: 'TREASURY.BANK_PAYMENTS.COLUMN.OP_ANTICIPO', // No. O.P. o Anticipo
      APPROVAL_DATE: 'TREASURY.BANK_PAYMENTS.COLUMN.APPROVAL_DATE', // Fecha Aprobación
      TOTAL: 'TREASURY.BANK_PAYMENTS.COLUMN.TOTAL', // Valor Total
      PAY_VALUE: 'TREASURY.BANK_PAYMENTS.LABEL.PAY_VALUE', // Valor a Pagar (reusa LABEL)
      DESCRIPTION: 'TREASURY.BANK_PAYMENTS.COLUMN.DESCRIPTION', // Descripción
      ACTIONS: 'COMMON.ACTIONS', // Acciones / Actions (common_keys)
      LOG_DATE: 'TREASURY.BANK_PAYMENTS.COLUMN.PAYMENT_DATE', // Fecha (reusa)
      LOG_USER: 'COLUMNS.USER', // Usuario
      LOG_PREV: 'TREASURY.BANK_PAYMENTS.COLUMN.STATUS', // Estado (reusa)
      LOG_NEXT: 'TREASURY.BANK_PAYMENTS.COLUMN.STATUS', // Estado (reusa)
      LOG_NOTE: 'ACCOUNTING.DEPRECIATION.LABEL.OBSERVATIONS', // Observaciones
      DED_TYPE: 'TREASURY.DEDUCTIONS.FORM.FIELDS.TIPO_DEDUCCION.LABEL', // Tipo Deducción
      DED_BENEFICIARY: 'TREASURY.DEDUCTIONS.FORM.FIELDS.NOMBRE_ACREEDOR.LABEL', // Beneficiario / acreedor
    },
    PLACEHOLDER: {
      SEARCH: 'ACTIONS.SEARCH', // Buscar
      SELECT_TYPE: 'TREASURY.BANK_PAYMENTS.PLACEHOLDER.SELECT_TYPE', // Seleccione tipo
      SELECT_ACCOUNT: 'TREASURY.BANK_PAYMENTS.ACTION.SELECT_ACCOUNT', // Seleccionar cuenta (reusa ACTION)
    },
    EMPTY: {
      DEFAULT: 'TREASURY.BANK_PAYMENTS.EMPTY.DEFAULT', // No hay comprobantes programados para pago el día de hoy
      SEARCH: 'TREASURY.BANK_PAYMENTS.EMPTY.SEARCH', // No se encontraron comprobantes que coincidan con la búsqueda
      DESCRIPTION: 'TREASURY.BANK_PAYMENTS.EMPTY.DESCRIPTION', // Intente con otro criterio o verifique la programación de egresos
      DETAIL: 'TREASURY.BANK_PAYMENTS.EMPTY.DETAIL', // Seleccione un comprobante con Pagar para ver el detalle
      DETAIL_DESCRIPTION: 'TREASURY.BANK_PAYMENTS.EMPTY.DETAIL_DESCRIPTION', // La información de O.P. / anticipo se muestra al seleccionar filas
      /** Reutiliza empties ya existentes (no nuevas keys en BD). */
      ORDERS: 'TREASURY.BANK_PAYMENTS.EMPTY.DETAIL',
      ORDERS_DESC: 'TREASURY.BANK_PAYMENTS.EMPTY.DETAIL_DESCRIPTION',
      LOG: 'TREASURY.BANK_PAYMENTS.EMPTY.DETAIL',
      LOG_DESC: 'TREASURY.BANK_PAYMENTS.EMPTY.DETAIL_DESCRIPTION',
      DEDUCTIONS: 'TREASURY.INCOME.DEDUCTIONS.TABLE.EMPTY.MESSAGE',
      DEDUCTIONS_DESC: 'TREASURY.INCOME.DEDUCTIONS.TABLE.EMPTY.DESCRIPTION',
    },
    COUNTER: {
      SINGULAR: 'TREASURY.BANK_PAYMENTS.COUNTER.SINGULAR', // comprobante
      PLURAL: 'TREASURY.BANK_PAYMENTS.COUNTER.PLURAL', // comprobantes
    },
    ACTION: {
      PAY: 'TREASURY.BANK_PAYMENTS.ACTION.PAY', // Pagar
      REJECT: 'TREASURY.BANK_PAYMENTS.ACTION.REJECT', // Rechazar
      SELECT_ACCOUNT: 'TREASURY.BANK_PAYMENTS.ACTION.SELECT_ACCOUNT', // Seleccionar cuenta
      PAY_ALL: 'TREASURY.BANK_PAYMENTS.ACTION.PAY_ALL', // Pagar todos (legacy)
      REJECT_ALL: 'TREASURY.BANK_PAYMENTS.ACTION.REJECT_ALL', // Rechazar todos (legacy)
      REFRESH: 'ACTIONS.REFRESH', // Refrescar (common_keys) — header como Aprobar Causación
      SAVE: 'ACTIONS.SAVE', // Guardar (common_keys)
      ACCEPT: 'ACTIONS.ACCEPT', // Aceptar (common_keys) — modal rechazo
      BACK: 'ACTIONS.BACK', // Volver (common_keys) — detalle consultar
      CANCEL: 'ACTIONS.CANCEL', // Cancelar (common_keys)
      VIEW: 'ACTIONS.VIEW', // Consultar (common_keys)
      CLOSE: 'TREASURY.PARAMETERS.ACCOUNT_SEARCH.CLOSE', // Cerrar / Close
    },
    MODAL: {
      SELECT_ACCOUNT: 'TREASURY.BANK_PAYMENTS.MODAL.SELECT_ACCOUNT', // Seleccionar cuenta bancaria
      REJECT_TITLE: 'TREASURY.BANK_PAYMENTS.MODAL.REJECT_TITLE', // Rechazar Documento(s) — alineado a Aprobar Causación
      REJECT_LABEL: 'TREASURY.BANK_PAYMENTS.MODAL.REJECT_LABEL', // Motivo de rechazo
      REJECT_PLACEHOLDER: 'TREASURY.BANK_PAYMENTS.MODAL.REJECT_PLACEHOLDER', // Ingrese el motivo del rechazo
      COL_CODE: 'TREASURY.BANK_PAYMENTS.MODAL.COL_CODE', // Código
      COL_NAME: 'TREASURY.BANK_PAYMENTS.MODAL.COL_NAME', // Nombre
      COL_BALANCE: 'TREASURY.BANK_PAYMENTS.LABEL.BALANCE', // Saldo (reusa LABEL.BALANCE)
      SEARCH_ACCOUNT: 'TREASURY.BANK_PAYMENTS.MODAL.SEARCH_ACCOUNT', // Buscar por código o nombre...
      CONFIRM_PAY_TITLE: 'TREASURY.BANK_PAYMENTS.MODAL.CONFIRM_PAY_TITLE', // Confirmar pago
    },
    LABEL: {
      METHOD: 'TREASURY.BANK_PAYMENTS.LABEL.METHOD', // Método de pago
      ACCOUNT: 'TREASURY.BANK_PAYMENTS.LABEL.ACCOUNT', // Cuenta bancaria
      ACCOUNT_CODE: 'TREASURY.PARAMETERS.FIELDS.ACCOUNT.CODE.LABEL', // Código Cuenta (reusa parámetros)
      ACCOUNT_NAME: 'TREASURY.PARAMETERS.FIELDS.ACCOUNT.NAME.LABEL', // Nombre Cuenta (reusa parámetros)
      BALANCE: 'TREASURY.BANK_PAYMENTS.LABEL.BALANCE', // Saldo
      ACCOUNT_BALANCE: 'TREASURY.BANK_PAYMENTS.LABEL.ACCOUNT_BALANCE', // Saldo de la Cuenta
      PAY_VALUE: 'TREASURY.BANK_PAYMENTS.LABEL.PAY_VALUE', // Valor a pagar
      FINAL_BALANCE: 'TREASURY.BANK_PAYMENTS.LABEL.FINAL_BALANCE', // Saldo final
      CHECK_NUMBER: 'TREASURY.BANK_PAYMENTS.LABEL.CHECK_NUMBER', // Número de cheque
      TIPO_CE: 'TREASURY.BANK_PAYMENTS.LABEL.TIPO_CE', // Tipo de Comprobante de Egreso
      SEARCH: 'LABELS.SEARCH', // Búsqueda (common_keys)
      PAYMENT_DATE: 'TREASURY.BANK_PAYMENTS.COLUMN.PAYMENT_DATE', // Fecha de pago (reusa COLUMN)
      TOTAL: 'TREASURY.BANK_PAYMENTS.COLUMN.TOTAL', // Valor Total (reusa COLUMN)
      CREATED_BY: 'TREASURY.EXPENSES.LABEL.CREATED_BY', // Elaboró
      APPROVED_BY: 'TREASURY.EXPENSES.LABEL.APPROVED_BY', // Aprueba
      NET_VALUE: 'TREASURY.BANK_PAYMENTS.LABEL.PAY_VALUE', // Valor a pagar (reusa)
    },
    OPTION: {
      GIRAR: 'TREASURY.BANK_PAYMENTS.OPTION.GIRAR', // Girar
      TRANSFERIR: 'TREASURY.BANK_PAYMENTS.OPTION.TRANSFERIR', // Transferir
      SIN_OP: 'TREASURY.BANK_PAYMENTS.OPTION.SIN_OP', // Sin orden de pago
      CON_OP: 'TREASURY.BANK_PAYMENTS.OPTION.CON_OP', // Con orden de pago
    },
    MESSAGE: {
      PAY_SUCCESS: 'TREASURY.BANK_PAYMENTS.MESSAGE.PAY_SUCCESS', // El pago/giro se ha registrado correctamente
      REJECT_SUCCESS: 'TREASURY.BANK_PAYMENTS.MESSAGE.REJECT_SUCCESS', // Comprobante(s) rechazado(s) correctamente
      SELECTION_REQUIRED: 'TREASURY.BANK_PAYMENTS.MESSAGE.SELECTION_REQUIRED', // Elige al menos un documento para el pago o rechazo
      ACCOUNT_REQUIRED: 'TREASURY.BANK_PAYMENTS.MESSAGE.ACCOUNT_REQUIRED', // Debe seleccionar al menos una cuenta
      ACCOUNT_ID_MISSING: 'TREASURY.BANK_PAYMENTS.MESSAGE.ACCOUNT_ID_MISSING', // La cuenta no trae cuentaBancariaId; pendiente backend
      METHOD_REQUIRED: 'TREASURY.BANK_PAYMENTS.MESSAGE.METHOD_REQUIRED', // Debe indicar Girar (cheque) o Transferir
      CHECK_REQUIRED: 'TREASURY.BANK_PAYMENTS.MESSAGE.CHECK_REQUIRED', // Al girar debe indicar el número de cheque
      MOTIVO_MIN: 'TREASURY.BANK_PAYMENTS.MESSAGE.MOTIVO_MIN', // El motivo de rechazo debe tener al menos {min} caracteres
      MOTIVO_MAX: 'TREASURY.BANK_PAYMENTS.MESSAGE.MOTIVO_MAX', // El motivo de rechazo no puede exceder {max} caracteres
      MOTIVO_REQUIRED: 'TREASURY.BANK_PAYMENTS.MESSAGE.MOTIVO_REQUIRED', // El motivo de rechazo es obligatorio
      CONFIRM_REJECT: 'TREASURY.BANK_PAYMENTS.MESSAGE.CONFIRM_REJECT', // Se realizará el rechazo del documento, ¿desea continuar?
      CONFIRM_PAY: 'TREASURY.BANK_PAYMENTS.MESSAGE.CONFIRM_PAY', // ¿Está seguro de procesar el pago de {count} comprobante(s)?
      LOAD_ERROR: 'TREASURY.BANK_PAYMENTS.MESSAGE.LOAD_ERROR', // No se pudo cargar el listado de comprobantes para pago
      READ_ERROR: 'TREASURY.BANK_PAYMENTS.MESSAGE.READ_ERROR', // No se pudo consultar el comprobante
      PAY_ERROR: 'TREASURY.BANK_PAYMENTS.MESSAGE.PAY_ERROR', // No se pudo procesar el pago. Intente nuevamente.
      REJECT_ERROR: 'TREASURY.BANK_PAYMENTS.MESSAGE.REJECT_ERROR', // No se pudo rechazar el/los comprobante(s).
      SEARCH_HINT_MIN: 'TREASURY.BANK_PAYMENTS.MESSAGE.SEARCH_HINT_MIN', // Debe ingresar entre {min} y {max} caracteres
      SEARCH_HINT_MAX: 'TREASURY.BANK_PAYMENTS.MESSAGE.SEARCH_HINT_MAX', // Máximo {max} caracteres
      PERMISSION_DENIED: 'TREASURY.BANK_PAYMENTS.MESSAGE.PERMISSION_DENIED', // No tiene permisos para realizar esta acción
    },
    PERMISSION: {
      DENIED_SAVE: 'TREASURY.BANK_PAYMENTS.PERMISSION.DENIED_SAVE', // No tiene permisos para guardar / pagar
      DENIED_REJECT: 'TREASURY.BANK_PAYMENTS.PERMISSION.DENIED_REJECT', // No tiene permisos para rechazar
      DENIED_VIEW: 'TREASURY.BANK_PAYMENTS.PERMISSION.DENIED_VIEW', // No tiene permisos para consultar
    },
  },
} as const;
